var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* tslint:disable */
/* eslint:disable */
/**
 * @typedef {string} Url
 */
/**
 * @typedef {string} GUID
 */
/**
 * @typedef {number} DateTime
 */
var dummy;
var defaultConfig = { endpoint: 'cashier-ugc' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
export var initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 64 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'cashier-ugc' });
    }
    ;
    /**
    * @typedef {Object} applePayCallBackReceivedParams
    * @property {number} amountLong - new amount * 100000
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} currency - currency
    * @property {string} fieldName - what was changed
    * @property {GUID} msid - null
    * @property {string} paymentProvider - payment_provider
    * @property {string} paymentmethod - payment method that was choosed
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: ApplePay call-back received. Evid: 264.
     * Event description: When user change some data on ApplePay side.
    
     * amountLong - Type: numeric. Desc: new amount * 100000
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * currency - Type: string. Desc: currency
     *
     * fieldName - Type: string. Desc: what was changed
     *
     * msid - Type: guid.
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * paymentmethod - Type: string. Desc: payment method that was choosed
     *
     * visitorId - Type: guid.
     * @param {applePayCallBackReceivedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.applePayCallBackReceived = function (params) {
        return this.bi.log(__assign({ evid: 264 }, params));
    };
    /**
    * @typedef {Object} businessLocationConfirmLoadedParams
    * @property {string} device - device_type
    * @property {string} merchantResolvedCountry - the country we get from the server
    * @property {GUID} msid - MSID
    * @property {boolean} status - status
    * @property {GUID} userGuid - UUID
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Business Location Confirm  loaded. Evid: 190.
     * Event description: Pop-up with @Confirm location@ CTA loaded.
    
     * device - Type: string. Desc: device_type
     *
     * merchantResolvedCountry - Type: string. Desc: the country we get from the server
     *
     * msid - Type: guid. Desc: MSID
     *
     * status - Type: bool. Desc: status
     *
     * userGuid - Type: guid. Desc: UUID
     *
     * visitorId - Type: guid.
     * @param {businessLocationConfirmLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.businessLocationConfirmLoaded = function (params) {
        return this.bi.log(__assign({ evid: 190 }, params));
    };
    /**
    * @typedef {Object} buyerChoosesPaymentMethodParams
    * @property {string} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} buyerComponent - -
    * @property {GUID} creditCardId - null if visitor doesn't have saved cc
    * @property {GUID} memberId - null if visitor is not logged in
    * @property {GUID} membershipId -
    * @property {GUID} msid - msid
    * @property {string} orderId - order id
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} pageType - payment component / sdk
    * @property {string} paymentCategory - payment_category
    * @property {string} paymentProvider - payment_provider
    * @property {string} paymentMethod - -
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout - Buyer chooses payment method. Evid: 105.
     * Event description: Buyer chooses payment method: Offline payment, MercadoPago, Paypal, Credit card.
    
     * appId - Type: string. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * buyerComponent - Type: string. Desc: -
     *
     * creditCardId - Type: guid. Desc: null if visitor doesn't have saved cc
     *
     * memberId - Type: guid. Desc: null if visitor is not logged in
     *
     * membershipId - Type: guid.
     *
     * msid - Type: guid. Desc: msid
     *
     * orderId - Type: string. Desc: order id
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * pageType - Type: string. Desc: payment component / sdk
     *
     * paymentCategory - Type: string. Desc: payment_category
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * paymentMethod - Type: string. Desc: -
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {buyerChoosesPaymentMethodParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.buyerChoosesPaymentMethod = function (params) {
        return this.bi.log(__assign({ evid: 105 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickUnsuspendAccountParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  unsuspend account. Evid: 417.
     * Event description: Employee click  unsuspend account.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickUnsuspendAccountParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickUnsuspendAccount = function (params) {
        return this.bi.log(__assign({ evid: 417 }, params));
    };
    /**
    * @typedef {Object} boAccountPageUnsuspendAccountOpenedParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {number} loadTime - load time
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - visitor id
    **/
    /**
     * Name: [BO] Account Page unsuspend account opened. Evid: 436.
     * Event description: Employee open unsuspend account.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * loadTime - Type: numeric. Desc: load time
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid. Desc: visitor id
     * @param {boAccountPageUnsuspendAccountOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageUnsuspendAccountOpened = function (params) {
        return this.bi.log(__assign({ evid: 436 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnDisconnectFromPaymentMethodsPageParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - payment method
    * @property {string} paymentProvider - payment provider
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: manual OB - Merchant- click on disconnect from Payment Methods page. Evid: 145.
     * Event description: Merchant- click on disconnect from Payment Methods page.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: payment method
     *
     * paymentProvider - Type: string. Desc: payment provider
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantClickOnDisconnectFromPaymentMethodsPageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnDisconnectFromPaymentMethodsPage = function (params) {
        return this.bi.log(__assign({ evid: 145 }, params));
    };
    /**
    * @typedef {Object} paymentDashboardFilterAppliedParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} selectedValue - what was exactly selected
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Payment Dashboard - filter applied. Evid: 157.
     * Event description: one of filters is applied (Currency / App / Status / Payment Method).
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * selectedValue - Type: string. Desc: what was exactly selected
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {paymentDashboardFilterAppliedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paymentDashboardFilterApplied = function (params) {
        return this.bi.log(__assign({ evid: 157 }, params));
    };
    /**
    * @typedef {Object} boAccountPageRefundPayoutOpenedParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {number} loadTime - load time
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - visitor id
    **/
    /**
     * Name: [BO] Account Page Refund Payout opened. Evid: 437.
     * Event description: Employee open Refund Payout in account.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * loadTime - Type: numeric. Desc: load time
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid. Desc: visitor id
     * @param {boAccountPageRefundPayoutOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageRefundPayoutOpened = function (params) {
        return this.bi.log(__assign({ evid: 437 }, params));
    };
    /**
    * @typedef {Object} merchantClickCompleteSetUpWpParams
    * @property {GUID} accountProfileId - wp profile id
    * @property {GUID} msid - null
    * @property {string} pageType - what page in the dashboard / origin page
    * @property {GUID} visitorId - null
    * @property {string} wpGeo - wp geo
    **/
    /**
     * Name: Merchant - Click Complete Set-Up WP. Evid: 244.
     * Event description: Merchant clicked complete set-up WP on cashier payment method page
    substitution of event 85:116.
    
     * accountProfileId - Type: guid. Desc: wp profile id
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: what page in the dashboard / origin page
     *
     * visitorId - Type: guid.
     *
     * wpGeo - Type: string. Desc: wp geo
     * @param {merchantClickCompleteSetUpWpParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickCompleteSetUpWp = function (params) {
        return this.bi.log(__assign({ evid: 244 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnRemoveFromPaymentMethodsPageParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - payment method
    * @property {string} paymentProvider - payment provider
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Remove Payment Method clicked. Evid: 146.
     * Event description: Merchant- click on remove from Payment Methods page in the not connected list.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: payment method
     *
     * paymentProvider - Type: string. Desc: payment provider
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantClickOnRemoveFromPaymentMethodsPageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnRemoveFromPaymentMethodsPage = function (params) {
        return this.bi.log(__assign({ evid: 146 }, params));
    };
    /**
    * @typedef {Object} wixCodePaymentCreationStartedParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id (cashier)
    * @property {number} duration - NOT IN USE: loading time in miliseconds
    * @property {string} errorDesc - NOT IN USE: error details
    * @property {string} merchantDefinedFields - INIT ONLY
    * @property {GUID} msid - msid
    * @property {string} orderSnapshotId - NOT IN USE: order_snapshot_id
    * @property {string} status - NOT IN USE: transaction status for thank you page
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Wix Code Payment - Creation started. Evid: 206.
     * Event description: Payment (Order) creation started after buyer initiates it (button click etc).
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id (cashier)
     *
     * duration - Type: numeric. Desc: NOT IN USE: loading time in miliseconds
     *
     * errorDesc - Type: string. Desc: NOT IN USE: error details
     *
     * merchantDefinedFields - Type: string. Desc: INIT ONLY
     *
     * msid - Type: guid. Desc: msid
     *
     * orderSnapshotId - Type: string. Desc: NOT IN USE: order_snapshot_id
     *
     * status - Type: string. Desc: NOT IN USE: transaction status for thank you page
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {wixCodePaymentCreationStartedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wixCodePaymentCreationStarted = function (params) {
        return this.bi.log(__assign({ evid: 206 }, params));
    };
    /**
    * @typedef {Object} installmentBannerListLoadedParams
    * @property {string} app_id - app id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - m
    * @property {string} offerId - list of offers that was shown ( array)
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: installment banner list loaded. Evid: 260.
     * Event description: start loading widget with data about installments ( Afterpay, laybuy, etc).
    
     * app_id - Type: string. Desc: app id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: m
     *
     * offerId - Type: string. Desc: list of offers that was shown ( array)
     *
     * visitorId - Type: guid.
     * @param {installmentBannerListLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.installmentBannerListLoaded = function (params) {
        return this.bi.log(__assign({ evid: 260 }, params));
    };
    /**
    * @typedef {Object} boMainPageSearchResultParams
    * @property {string} displayName - employee displayName
    * @property {string} errorMessage - error if search was failed
    * @property {number} loadTime - how long users wait for result
    * @property {GUID} msid - null
    * @property {number} returnedResults - count of returned results
    * @property {string} searchType - email, url, msid, uuid, etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Main Page search result. Evid: 402.
     * Event description: Employee gets search results.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * errorMessage - Type: string. Desc: error if search was failed
     *
     * loadTime - Type: numeric. Desc: how long users wait for result
     *
     * msid - Type: guid.
     *
     * returnedResults - Type: numeric. Desc: count of returned results
     *
     * searchType - Type: string. Desc: email, url, msid, uuid, etc
     *
     * visitorId - Type: guid.
     * @param {boMainPageSearchResultParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boMainPageSearchResult = function (params) {
        return this.bi.log(__assign({ evid: 402 }, params));
    };
    /**
    * @typedef {Object} merchantVerifyAccountClicked277Params
    * @property {GUID} msid - null
    * @property {string} pageType - page where user at
    * @property {string} paymentCategory - payment method
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - My account meet the requirement. Evid: 277.
     * Event description: Click on Verify Account on Accept Payment.
    
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: page where user at
     *
     * paymentCategory - Type: string. Desc: payment method
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantVerifyAccountClicked277Params} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantVerifyAccountClicked277 = function (params) {
        return this.bi.log(__assign({ evid: 277 }, params));
    };
    /**
    * @typedef {Object} checkoutThankYouPageLoadParams
    * @property {string} appId - app_id
    * @property {string} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} orderId - vertical order id
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} transactionStatus - transaction status
    * @property {string} uuid - uuid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout - Thank You Page Load. Evid: 267.
     * Event description: Thank You Page was shown to the visitor after the order completed for InApp browser.
    
     * appId - Type: string. Desc: app_id
     *
     * appInstanceId - Type: string. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * orderId - Type: string. Desc: vertical order id
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * transactionStatus - Type: string. Desc: transaction status
     *
     * uuid - Type: string. Desc: uuid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {checkoutThankYouPageLoadParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkoutThankYouPageLoad = function (params) {
        return this.bi.log(__assign({ evid: 267 }, params));
    };
    /**
    * @typedef {Object} wixCodePaymentCreationCompletedParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id (cashier)
    * @property {number} duration - loading time in miliseconds
    * @property {string} errorDesc - in case of error
    * @property {string} merchantDefinedFields - INIT ONLY
    * @property {GUID} msid - msid
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {boolean} status - creation status: true / false
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Wix Code Payment - Creation completed. Evid: 207.
     * Event description: Payment (Order) creation completed.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id (cashier)
     *
     * duration - Type: numeric. Desc: loading time in miliseconds
     *
     * errorDesc - Type: string. Desc: in case of error
     *
     * merchantDefinedFields - Type: string. Desc: INIT ONLY
     *
     * msid - Type: guid. Desc: msid
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * status - Type: bool. Desc: creation status: true / false
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {wixCodePaymentCreationCompletedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wixCodePaymentCreationCompleted = function (params) {
        return this.bi.log(__assign({ evid: 207 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnAddParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} origin - notification/button
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant-click on +add. Evid: 143.
     * Event description: Merchant-click on +add  on the second page of the payment methods.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * origin - Type: string. Desc: notification/button
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantClickOnAddParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnAdd = function (params) {
        return this.bi.log(__assign({ evid: 143 }, params));
    };
    /**
    * @typedef {Object} merchantUnselectPaymentCategoryToConnectParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} origin - - not in use
    * @property {string} pageName - Payment Method_first page
    * @property {string} paymentCategory - Credit Card
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant-unselect payment category to connect. Evid: 138.
     * Event description: Merchant-unselect payment category to connect.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * origin - Type: string. Desc: - not in use
     *
     * pageName - Type: string. Desc: Payment Method_first page
     *
     * paymentCategory - Type: string. Desc: Credit Card
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantUnselectPaymentCategoryToConnectParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantUnselectPaymentCategoryToConnect = function (params) {
        return this.bi.log(__assign({ evid: 138 }, params));
    };
    /**
    * @typedef {Object} boSitePageTransactionRefundComfirmedParams
    * @property {number} amount - refunded amount
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} reason - reason
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page transaction refund comfirmed. Evid: 411.
     * Event description: Employee choose amount and confirm refund.
    
     * amount - Type: numeric. Desc: refunded amount
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * reason - Type: string. Desc: reason
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boSitePageTransactionRefundComfirmedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageTransactionRefundComfirmed = function (params) {
        return this.bi.log(__assign({ evid: 411 }, params));
    };
    /**
    * @typedef {Object} boSitePageTransactionDrawerCloseParams
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page transaction drawer close. Evid: 409.
     * Event description: Employee close transaction drawer.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boSitePageTransactionDrawerCloseParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageTransactionDrawerClose = function (params) {
        return this.bi.log(__assign({ evid: 409 }, params));
    };
    /**
    * @typedef {Object} paymentDashboardViewMoreTransactionsClickedParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {number} transactionsShown - current number of visible transactions per page
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Payment Dashboard - view more transactions clicked. Evid: 159.
     * Event description: when user clicks to view 10 more transactions in the end of the list.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * transactionsShown - Type: numeric. Desc: current number of visible transactions per page
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {paymentDashboardViewMoreTransactionsClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paymentDashboardViewMoreTransactionsClicked = function (params) {
        return this.bi.log(__assign({ evid: 159 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnCanelInTheUpdateModalParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} pageName - add more payment methods
    * @property {string} paymentCategory - paymentCategory
    * @property {string} paymentProvider - payment_provider
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant-click on cancel in the update modal. Evid: 141.
     * Event description: Merchant--click on canel in the update modal- General event for click on cancel or exsit in the modal.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * pageName - Type: string. Desc: add more payment methods
     *
     * paymentCategory - Type: string. Desc: paymentCategory
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantClickOnCanelInTheUpdateModalParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnCanelInTheUpdateModal = function (params) {
        return this.bi.log(__assign({ evid: 141 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickConfirmRefundPayoutParams
    * @property {GUID} accountId - provider account id
    * @property {number} amount - payout amount
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} reason - reason
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  Confirm   Refund Payout. Evid: 426.
     * Event description: Employee click Confirm    Refund Payout.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * amount - Type: numeric. Desc: payout amount
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * reason - Type: string. Desc: reason
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickConfirmRefundPayoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickConfirmRefundPayout = function (params) {
        return this.bi.log(__assign({ evid: 426 }, params));
    };
    /**
    * @typedef {Object} wixCodePaymentInitializationStartedParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id (cashier)
    * @property {number} duration - NOT IN USE: loading time in miliseconds from buyer activity to page started loading
    * @property {string} errorDesc - NOT IN USE: error details
    * @property {string} merchantDefinedFields - buyer details, specified by merchant
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {boolean} showThankYouPage - merchant enables thank you page
    * @property {boolean} status - NOT IN USE: creation status: true / false
    * @property {boolean} termsAndConditions - true if shown, false is not shown
    * @property {boolean} thunderbolt - if loading was from thunderbolt then TRUE
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Wix Code Payment - Initialization started. Evid: 208.
     * Event description: Payment Initialization started.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id (cashier)
     *
     * duration - Type: numeric. Desc: NOT IN USE: loading time in miliseconds from buyer activity to page started loading
     *
     * errorDesc - Type: string. Desc: NOT IN USE: error details
     *
     * merchantDefinedFields - Type: string. Desc: buyer details, specified by merchant
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * showThankYouPage - Type: bool. Desc: merchant enables thank you page
     *
     * status - Type: bool. Desc: NOT IN USE: creation status: true / false
     *
     * termsAndConditions - Type: bool. Desc: true if shown, false is not shown
     *
     * thunderbolt - Type: bool. Desc: if loading was from thunderbolt then TRUE
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {wixCodePaymentInitializationStartedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wixCodePaymentInitializationStarted = function (params) {
        return this.bi.log(__assign({ evid: 208 }, params));
    };
    /**
    * @typedef {Object} checkoutPaymentComponentShownParams
    * @property {string} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} buyerComponent - react if new
    * @property {GUID} creditCardId - null if visitor is not logged in or doesn't have saved cc
    * @property {number} hasSavedCreditCards - null if visitor is not logged in or doesn't have saved cc
    * @property {GUID} memberId - null if visitor is not logged in
    * @property {GUID} membershipId -
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} orderId - vertical order id
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} pageType - payment component / sdk
    * @property {string} payWith - default payment category
    * @property {string} paymentCategory - CreditCard/Ewallet,offline
    * @property {string} paymentProvider - com.stripe/net.authorize
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout - Payment Component Shown. Evid: 180.
     * Event description: Payment Component is shown to a buyer.
    
     * appId - Type: string. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * buyerComponent - Type: string. Desc: react if new
     *
     * creditCardId - Type: guid. Desc: null if visitor is not logged in or doesn't have saved cc
     *
     * hasSavedCreditCards - Type: numeric. Desc: null if visitor is not logged in or doesn't have saved cc
     *
     * memberId - Type: guid. Desc: null if visitor is not logged in
     *
     * membershipId - Type: guid.
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderId - Type: guid. Desc: vertical order id
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * pageType - Type: string. Desc: payment component / sdk
     *
     * payWith - Type: string. Desc: default payment category
     *
     * paymentCategory - Type: string. Desc: CreditCard/Ewallet,offline
     *
     * paymentProvider - Type: string. Desc: com.stripe/net.authorize
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {checkoutPaymentComponentShownParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkoutPaymentComponentShown = function (params) {
        return this.bi.log(__assign({ evid: 180 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickCancelUnsuspendAccountParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  Cancel unsuspend account. Evid: 419.
     * Event description: Employee click Cancel unsuspend account.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickCancelUnsuspendAccountParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickCancelUnsuspendAccount = function (params) {
        return this.bi.log(__assign({ evid: 419 }, params));
    };
    /**
    * @typedef {Object} installmentBannerLoadStartParams
    * @property {string} app_id - app id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - null
    * @property {string} productId - product id
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: installment banner load start. Evid: 257.
     * Event description: start loading widget with data about installments ( Afterpay, laybuy, etc).
    
     * app_id - Type: string. Desc: app id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid.
     *
     * productId - Type: string. Desc: product id
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {installmentBannerLoadStartParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.installmentBannerLoadStart = function (params) {
        return this.bi.log(__assign({ evid: 257 }, params));
    };
    /**
    * @typedef {Object} boMainPageOpenParams
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - null
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Main Page open. Evid: 400.
     * Event description: Employee open Main Page in Back Office.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid.
     *
     * visitorId - Type: guid.
     * @param {boMainPageOpenParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boMainPageOpen = function (params) {
        return this.bi.log(__assign({ evid: 400 }, params));
    };
    /**
    * @typedef {Object} spbButtonStartInitializationCheckoutParams
    * @property {string} cartId - cart id
    * @property {GUID} msid - msid
    * @property {string} paymentProvider - payment_provider that chosen (PayPal, Wixpayments etc.)
    * @property {string} paymentmethod - payment method in provider (Venmo, PayPal Credit etc.)
    * @property {string} sessionId - unique payment session to connect orders and trxs
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: SPB button startInitializationCheckout. Evid: 213.
     * Event description: Smart Payment Button start Initialization Checkout (start creating order on PayPal).
    
     * cartId - Type: string. Desc: cart id
     *
     * msid - Type: guid. Desc: msid
     *
     * paymentProvider - Type: string. Desc: payment_provider that chosen (PayPal, Wixpayments etc.)
     *
     * paymentmethod - Type: string. Desc: payment method in provider (Venmo, PayPal Credit etc.)
     *
     * sessionId - Type: string. Desc: unique payment session to connect orders and trxs
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {spbButtonStartInitializationCheckoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.spbButtonStartInitializationCheckout = function (params) {
        return this.bi.log(__assign({ evid: 213 }, params));
    };
    /**
    * @typedef {Object} merchantEnableAdvancedOptionsClickedParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - Credit Card
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Enable Advanced Options clicked. Evid: 163.
     * Event description: Click enable advance options in Payment Methods Page - in order to grant permissions for recurring payment.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: Credit Card
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantEnableAdvancedOptionsClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantEnableAdvancedOptionsClicked = function (params) {
        return this.bi.log(__assign({ evid: 163 }, params));
    };
    /**
    * @typedef {Object} merchantModalWasShownToUserParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} modal_name - disconnect_last_provider_popup / switch_provider etc
    * @property {GUID} msid - msid
    * @property {string} page - page where modal appear
    * @property {string} paymentCategory - currently connected category
    * @property {string} paymentProvider - currently connected provider
    * @property {string} platformName - desktop/oneApp etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Modal was shown to user. Evid: 248.
     * Event description: Modal was shown to user on accept_payments / manage_page / third_party_cc_providers.
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * modal_name - Type: string. Desc: disconnect_last_provider_popup / switch_provider etc
     *
     * msid - Type: guid. Desc: msid
     *
     * page - Type: string. Desc: page where modal appear
     *
     * paymentCategory - Type: string. Desc: currently connected category
     *
     * paymentProvider - Type: string. Desc: currently connected provider
     *
     * platformName - Type: string. Desc: desktop/oneApp etc
     *
     * visitorId - Type: guid.
     * @param {merchantModalWasShownToUserParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantModalWasShownToUser = function (params) {
        return this.bi.log(__assign({ evid: 248 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickConfirmUnsuspendAccountParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  Confirm unsuspend account. Evid: 418.
     * Event description: Employee click Confirm  unsuspend account.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickConfirmUnsuspendAccountParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickConfirmUnsuspendAccount = function (params) {
        return this.bi.log(__assign({ evid: 418 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickProcessPayoutParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - null
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click Process Payout. Evid: 421.
     * Event description: Employee click   Process Payout in account.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string.
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickProcessPayoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickProcessPayout = function (params) {
        return this.bi.log(__assign({ evid: 421 }, params));
    };
    /**
    * @typedef {Object} paymentModalClosedParams
    * @property {string} cartId - cart id
    * @property {GUID} msid - msid
    * @property {string} paymentProvider - payment_provider that chosen (PayPal, Wixpayments etc.)
    * @property {string} paymentmethod - payment method in provider (Venmo, PayPal Credit etc.)
    * @property {string} sessionId - unique payment session to connect orders and trxs
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Payment modal closed. Evid: 212.
     * Event description: User click to close payment external modal window/tab.
    
     * cartId - Type: string. Desc: cart id
     *
     * msid - Type: guid. Desc: msid
     *
     * paymentProvider - Type: string. Desc: payment_provider that chosen (PayPal, Wixpayments etc.)
     *
     * paymentmethod - Type: string. Desc: payment method in provider (Venmo, PayPal Credit etc.)
     *
     * sessionId - Type: string. Desc: unique payment session to connect orders and trxs
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {paymentModalClosedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paymentModalClosed = function (params) {
        return this.bi.log(__assign({ evid: 212 }, params));
    };
    /**
    * @typedef {Object} boSitePageClickUserDrawerParams
    * @property {string} displayName - employee displayName
    * @property {number} loadTime - loadtime
    * @property {GUID} msid - msid
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page click user drawer. Evid: 404.
     * Event description: Employee click user drawer.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * loadTime - Type: numeric. Desc: loadtime
     *
     * msid - Type: guid. Desc: msid
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {boSitePageClickUserDrawerParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageClickUserDrawer = function (params) {
        return this.bi.log(__assign({ evid: 404 }, params));
    };
    /**
    * @typedef {Object} merchantPaymentDashboardRemovedPopUpParams
    * @property {GUID} msid - null
    * @property {GUID} uuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Payment Dashboard removed pop-up. Evid: 195.
     * Event description: When users, who saw payment dashboard previously, goes to Accept Payment Tab we notify him that place changes.
    
     * msid - Type: guid.
     *
     * uuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantPaymentDashboardRemovedPopUpParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantPaymentDashboardRemovedPopUp = function (params) {
        return this.bi.log(__assign({ evid: 195 }, params));
    };
    /**
    * @typedef {Object} merchantSelectUnselectAdditionalPaymentMethodAtManageAccountParams
    * @property {string} app_id - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} paymentMethod - creditCard,paypal
    * @property {string} paymentProvider - payment provider
    * @property {boolean} selected - Select/unselect options at Manage account tab. True=selected, false=unselected
    * @property {string} selectedValue - e.g. PayPal Credit
    * @property {GUID} uuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Select/unselect additional payment method at Manage account. Evid: 199.
     * Event description: Merchant select/unselect additional provider settings at Manage account tab.
    
     * app_id - Type: string. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * paymentMethod - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string. Desc: payment provider
     *
     * selected - Type: bool. Desc: Select/unselect options at Manage account tab. True=selected, false=unselected
     *
     * selectedValue - Type: string. Desc: e.g. PayPal Credit
     *
     * uuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {merchantSelectUnselectAdditionalPaymentMethodAtManageAccountParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantSelectUnselectAdditionalPaymentMethodAtManageAccount = function (params) {
        return this.bi.log(__assign({ evid: 199 }, params));
    };
    /**
    * @typedef {Object} checkOutPaymentMethodValidationCompletedParams
    * @property {string} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} buyercomponent - buyercomponent
    * @property {GUID} memberId - member_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderId - order id
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} pagetype - pagetype
    * @property {string} paymentCategory - payment_category
    * @property {string} paymentProvider - payment_provider
    * @property {string} paymentMethod -
    * @property {string} reason - list of fields with the problem in case when status = false
    * @property {boolean} status - true if success
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout - Payment Method Validation Completed. Evid: 165.
     * Event description: The result of Payment Method Validation.
    
     * appId - Type: string. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * buyercomponent - Type: string. Desc: buyercomponent
     *
     * memberId - Type: guid. Desc: member_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderId - Type: string. Desc: order id
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * pagetype - Type: string. Desc: pagetype
     *
     * paymentCategory - Type: string. Desc: payment_category
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * paymentMethod - Type: string.
     *
     * reason - Type: string. Desc: list of fields with the problem in case when status = false
     *
     * status - Type: bool. Desc: true if success
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {checkOutPaymentMethodValidationCompletedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkOutPaymentMethodValidationCompleted = function (params) {
        return this.bi.log(__assign({ evid: 165 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickRefundPayoutParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click Refund Payout. Evid: 425.
     * Event description: Employee click    Refund Payout in account.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickRefundPayoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickRefundPayout = function (params) {
        return this.bi.log(__assign({ evid: 425 }, params));
    };
    /**
    * @typedef {Object} spbButtonRenderedParams
    * @property {string} cartId - cart id
    * @property {number} loadTime - time from initial to render
    * @property {GUID} msid - msid
    * @property {string} paymentProvider - payment_provider that chosen (PayPal, Wixpayments etc.)
    * @property {string} paymentmethod - payment method in provider (Venmo, PayPal Credit etc.)
    * @property {boolean} requestShipping - if Stores ask about shipping address
    * @property {string} sessionId - unique payment session to connect orders and trxs
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: SPB button rendered. Evid: 210.
     * Event description: Smart Payment Button was rendered.
    
     * cartId - Type: string. Desc: cart id
     *
     * loadTime - Type: numeric. Desc: time from initial to render
     *
     * msid - Type: guid. Desc: msid
     *
     * paymentProvider - Type: string. Desc: payment_provider that chosen (PayPal, Wixpayments etc.)
     *
     * paymentmethod - Type: string. Desc: payment method in provider (Venmo, PayPal Credit etc.)
     *
     * requestShipping - Type: bool. Desc: if Stores ask about shipping address
     *
     * sessionId - Type: string. Desc: unique payment session to connect orders and trxs
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {spbButtonRenderedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.spbButtonRendered = function (params) {
        return this.bi.log(__assign({ evid: 210 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnEditAccountDetailsParams
    * @property {GUID} msid - null
    * @property {string} pageType - manage_page
    * @property {string} paymentCategory - creditCard,cardReader etc
    * @property {string} paymentProvider - wixpay_adyen, wixpay_stripe
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Click on Edit Account details. Evid: 269.
     * Event description: Click on Edit Account details at Wix Payments Manage Page.
    
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: manage_page
     *
     * paymentCategory - Type: string. Desc: creditCard,cardReader etc
     *
     * paymentProvider - Type: string. Desc: wixpay_adyen, wixpay_stripe
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantClickOnEditAccountDetailsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnEditAccountDetails = function (params) {
        return this.bi.log(__assign({ evid: 269 }, params));
    };
    /**
    * @typedef {Object} merchantContinueToChooseMethodsForConnectParams
    * @property {GUID} appId - cashier app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} availableValue - list of available payment methods
    * @property {string} businessLocation - 2-letter country code of location selected by a user
    * @property {string} defaultValue - list of selected payment methods checked by default
    * @property {GUID} msid - msid
    * @property {string} selectedValue - list of selected payment methods to continue
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Continue to Choose Methods for Connect. Evid: 184.
     * Event description: Merchant clicks Continue on Welcome screen. If he chooses at least 1 online pm with autoconnect, he will be leaded to next screen.
    
     * appId - Type: guid. Desc: cashier app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * availableValue - Type: string. Desc: list of available payment methods
     *
     * businessLocation - Type: string. Desc: 2-letter country code of location selected by a user
     *
     * defaultValue - Type: string. Desc: list of selected payment methods checked by default
     *
     * msid - Type: guid. Desc: msid
     *
     * selectedValue - Type: string. Desc: list of selected payment methods to continue
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantContinueToChooseMethodsForConnectParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantContinueToChooseMethodsForConnect = function (params) {
        return this.bi.log(__assign({ evid: 184 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickConfirmProcessPayoutParams
    * @property {GUID} accountId - provider account id
    * @property {number} amount - payout amount
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  Confirm  Process Payout. Evid: 422.
     * Event description: Employee click Confirm   Process Payout.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * amount - Type: numeric. Desc: payout amount
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickConfirmProcessPayoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickConfirmProcessPayout = function (params) {
        return this.bi.log(__assign({ evid: 422 }, params));
    };
    /**
    * @typedef {Object} wixCodeCheckOutBuyerMovesInAFunnelParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id (cashier)
    * @property {GUID} cashierInstanceId - cashier_instance_id
    * @property {string} direction - button name (incl. close)
    * @property {number} duration - NOT IN USE: loading time in miliseconds
    * @property {string} errorDesc - NOT IN USE: error details
    * @property {string} errorType - NOT IN USE: generic, input
    * @property {string} merchantDefinedFields - buyer details, specified by merchant
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} page - name of the page
    * @property {string} pageFrom - NOT IN USE: page buyer is redirected from
    * @property {string} pageTo - page buyer will be navigated to
    * @property {string} paymentMethodsAvailable - list of available payment methods
    * @property {string} paymentMethodSelected - payment method selected if known
    * @property {string} selectedCountry - country chosen by buyer
    * @property {boolean} showThankYouPage - merchant enables thank you page
    * @property {string} status - NOT IN USE: transaction status for thank you page
    * @property {boolean} termsAndConditions - true if shown, false is not shown
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Wix Code Checkout - Buyer moves in a funnel. Evid: 202.
     * Event description: Wix Code Check out - Buyer moves in a funnel.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id (cashier)
     *
     * cashierInstanceId - Type: guid. Desc: cashier_instance_id
     *
     * direction - Type: string. Desc: button name (incl. close)
     *
     * duration - Type: numeric. Desc: NOT IN USE: loading time in miliseconds
     *
     * errorDesc - Type: string. Desc: NOT IN USE: error details
     *
     * errorType - Type: string. Desc: NOT IN USE: generic, input
     *
     * merchantDefinedFields - Type: string. Desc: buyer details, specified by merchant
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * page - Type: string. Desc: name of the page
     *
     * pageFrom - Type: string. Desc: NOT IN USE: page buyer is redirected from
     *
     * pageTo - Type: string. Desc: page buyer will be navigated to
     *
     * paymentMethodsAvailable - Type: string. Desc: list of available payment methods
     *
     * paymentMethodSelected - Type: string. Desc: payment method selected if known
     *
     * selectedCountry - Type: string. Desc: country chosen by buyer
     *
     * showThankYouPage - Type: bool. Desc: merchant enables thank you page
     *
     * status - Type: string. Desc: NOT IN USE: transaction status for thank you page
     *
     * termsAndConditions - Type: bool. Desc: true if shown, false is not shown
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {wixCodeCheckOutBuyerMovesInAFunnelParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wixCodeCheckOutBuyerMovesInAFunnel = function (params) {
        return this.bi.log(__assign({ evid: 202 }, params));
    };
    /**
    * @typedef {Object} merchantToastShowedParams
    * @property {GUID} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - null
    * @property {string} pageType - what page in the dashboard / origin page
    * @property {string} text - text showed on toast
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - toast showed. Evid: 247.
     * Event description: Toast notification was showed to merchants.
    
     * appId - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: what page in the dashboard / origin page
     *
     * text - Type: string. Desc: text showed on toast
     *
     * visitorId - Type: guid.
     * @param {merchantToastShowedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantToastShowed = function (params) {
        return this.bi.log(__assign({ evid: 247 }, params));
    };
    /**
    * @typedef {Object} paymentDashboardTabSelectedParams
    * @property {string} accountStatus - wix payments account status
    * @property {string} errorMessage - key for message ( kyc / compliance / other)
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} pageType - wp_settings/ payouts / accept_payments
    * @property {string} platformName - null(desktop)/oneApp/partnets etc
    * @property {string} viewMode - siteLevel'/ 'accountLevel' etc
    * @property {GUID} visitorId - visitor_id
    * @property {string} wpGeo - GEO
    **/
    /**
     * Name: Merchant - Click Accept Terms and Conditions. Evid: 155.
     * Event description: Merchant - Click Accept Terms and Conditions TOS notification at WP settings.
    
     * accountStatus - Type: string. Desc: wix payments account status
     *
     * errorMessage - Type: string. Desc: key for message ( kyc / compliance / other)
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * pageType - Type: string. Desc: wp_settings/ payouts / accept_payments
     *
     * platformName - Type: string. Desc: null(desktop)/oneApp/partnets etc
     *
     * viewMode - Type: string. Desc: siteLevel'/ 'accountLevel' etc
     *
     * visitorId - Type: guid. Desc: visitor_id
     *
     * wpGeo - Type: string. Desc: GEO
     * @param {paymentDashboardTabSelectedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paymentDashboardTabSelected = function (params) {
        return this.bi.log(__assign({ evid: 155 }, params));
    };
    /**
    * @typedef {Object} boletoPrintButtonParams
    * @property {number} amountLong - amount
    * @property {DateTime} due_date - due_date on boleto
    * @property {GUID} msid - null
    * @property {string} orderSnapshotId - Cashier order snapshot id
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Boleto print button. Evid: 234.
     * Event description: When User click print boleto.
    
     * amountLong - Type: numeric. Desc: amount
     *
     * due_date - Type: datetime. Desc: due_date on boleto
     *
     * msid - Type: guid.
     *
     * orderSnapshotId - Type: string. Desc: Cashier order snapshot id
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boletoPrintButtonParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boletoPrintButton = function (params) {
        return this.bi.log(__assign({ evid: 234 }, params));
    };
    /**
    * @typedef {Object} spbShippingMethodChangedParams
    * @property {number} amountLong - new amount ( * 100 000)
    * @property {GUID} appInstanceId - vertical instance id
    * @property {string} currency - new value
    * @property {string} externalOrderId - provider order id // for SPB = payPal order id
    * @property {GUID} msid - site id
    * @property {string} paymentMethod - new method, when method was changed
    * @property {string} sessionId - unique payment session to connect orders and trxs
    * @property {GUID} visitorId - visitor id
    **/
    /**
     * Name: SPB shipping/method changed. Evid: 198.
     * Event description: in case of PayPal Smart button we want to know when user change shipping address or payment method on provider side.
    
     * amountLong - Type: numeric. Desc: new amount ( * 100 000)
     *
     * appInstanceId - Type: guid. Desc: vertical instance id
     *
     * currency - Type: string. Desc: new value
     *
     * externalOrderId - Type: string. Desc: provider order id // for SPB = payPal order id
     *
     * msid - Type: guid. Desc: site id
     *
     * paymentMethod - Type: string. Desc: new method, when method was changed
     *
     * sessionId - Type: string. Desc: unique payment session to connect orders and trxs
     *
     * visitorId - Type: guid. Desc: visitor id
     * @param {spbShippingMethodChangedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.spbShippingMethodChanged = function (params) {
        return this.bi.log(__assign({ evid: 198 }, params));
    };
    /**
    * @typedef {Object} merchantWixPaymentsLbInteractionParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} interaction - close / see_all_methods / create_account
    * @property {GUID} msid - msid
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Wix Payments LB interaction. Evid: 169.
     * Event description: when user interacts with Wix Payments LB.
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * interaction - Type: string. Desc: close / see_all_methods / create_account
     *
     * msid - Type: guid. Desc: msid
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {merchantWixPaymentsLbInteractionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantWixPaymentsLbInteraction = function (params) {
        return this.bi.log(__assign({ evid: 169 }, params));
    };
    /**
    * @typedef {Object} paymentDashboardRefundRequestConfirmedParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} transactionId - transaction_id
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Payment Dashboard - Refund request confirmed. Evid: 161.
     * Event description: user confirms that he wants to refund transaction.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * transactionId - Type: guid. Desc: transaction_id
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {paymentDashboardRefundRequestConfirmedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paymentDashboardRefundRequestConfirmed = function (params) {
        return this.bi.log(__assign({ evid: 161 }, params));
    };
    /**
    * @typedef {Object} merchantClickContinueAtPaymentOptionsParams
    * @property {string} avalableCategory - available payment methods  (creditCard/cardReader/applePay)
    * @property {GUID} msid - null
    * @property {string} pageType - payment_options
    * @property {string} paymentProvider - wixpay_adyen/wixpay_stripe
    * @property {string} selectedCategory - selected payment method (creditCard/cardReader)
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Click Continue at Payment Options. Evid: 275.
     * Event description: Merchant Clicks Continue at Payment Options when connecting Wix Payments.
    
     * avalableCategory - Type: string. Desc: available payment methods  (creditCard/cardReader/applePay)
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: payment_options
     *
     * paymentProvider - Type: string. Desc: wixpay_adyen/wixpay_stripe
     *
     * selectedCategory - Type: string. Desc: selected payment method (creditCard/cardReader)
     *
     * visitorId - Type: guid.
     * @param {merchantClickContinueAtPaymentOptionsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickContinueAtPaymentOptions = function (params) {
        return this.bi.log(__assign({ evid: 275 }, params));
    };
    /**
    * @typedef {Object} pixModalClosedParams
    * @property {number} amountLong - amount
    * @property {GUID} msid - msid
    * @property {string} orderSnapshotId - Cashier order snapshot id
    * @property {string} paymentMethodType - payment_method_type
    * @property {string} paymentProvider - Payment Provider
    * @property {string} reason - close modal reason ( Success, Decline, Timeout)
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Instant PM Modal closed. Evid: 288.
     * Event description: When User close PIX popup.
    
     * amountLong - Type: numeric. Desc: amount
     *
     * msid - Type: guid. Desc: msid
     *
     * orderSnapshotId - Type: string. Desc: Cashier order snapshot id
     *
     * paymentMethodType - Type: string. Desc: payment_method_type
     *
     * paymentProvider - Type: string. Desc: Payment Provider
     *
     * reason - Type: string. Desc: close modal reason ( Success, Decline, Timeout)
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {pixModalClosedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.pixModalClosed = function (params) {
        return this.bi.log(__assign({ evid: 288 }, params));
    };
    /**
    * @typedef {Object} merchantSelectPmUnderWixPaymentParams
    * @property {boolean} isSelected - true/false
    * @property {GUID} msid - null
    * @property {string} pageType - payment_options
    * @property {string} paymentCategory - creditCard,cardReader,applePay
    * @property {string} paymentProvider - wixpay_stripe
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Select PM under Wix Payment. Evid: 268.
     * Event description: Merchant click on the toggle to select/unselect additional Payment Method when connecting Wix Payments.
    
     * isSelected - Type: bool. Desc: true/false
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: payment_options
     *
     * paymentCategory - Type: string. Desc: creditCard,cardReader,applePay
     *
     * paymentProvider - Type: string. Desc: wixpay_stripe
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantSelectPmUnderWixPaymentParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantSelectPmUnderWixPayment = function (params) {
        return this.bi.log(__assign({ evid: 268 }, params));
    };
    /**
    * @typedef {Object} boSitePageCloseUserDrawerParams
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page close user drawer. Evid: 405.
     * Event description: Employee click close in user drawer.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {boSitePageCloseUserDrawerParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageCloseUserDrawer = function (params) {
        return this.bi.log(__assign({ evid: 405 }, params));
    };
    /**
    * @typedef {Object} merchantCompleteSetUpLearnMoreClickedParams
    * @property {GUID} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} origin - autoconnect / add provider / set up / set up to activate / change provider
    * @property {string} paymentCategory - Credit Card,PayPal,Mercado Pago, Offline
    * @property {string} paymentProvider - payment_provider
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Complete Set Up Learn More clicked. Evid: 154.
     * Event description: Merchant click on setup account to activate in smart ob - different sources.
    
     * appId - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: autoconnect / add provider / set up / set up to activate / change provider
     *
     * paymentCategory - Type: string. Desc: Credit Card,PayPal,Mercado Pago, Offline
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantCompleteSetUpLearnMoreClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantCompleteSetUpLearnMoreClicked = function (params) {
        return this.bi.log(__assign({ evid: 154 }, params));
    };
    /**
    * @typedef {Object} merchantClicksOnPublishSiteParams
    * @property {string} bannerName - wix_payments_card_notification
    * @property {string} cta - publish
    * @property {GUID} msid - null
    * @property {string} pageType - page where banner was shown - accept_payment/manage_page etc
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - clicks on Publish site. Evid: 283.
     * Event description: User clicks on Publish site on the banner in order to be verified.
    
     * bannerName - Type: string. Desc: wix_payments_card_notification
     *
     * cta - Type: string. Desc: publish
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: page where banner was shown - accept_payment/manage_page etc
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantClicksOnPublishSiteParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClicksOnPublishSite = function (params) {
        return this.bi.log(__assign({ evid: 283 }, params));
    };
    /**
    * @typedef {Object} merchantCtaAtProhibitedProductsPageClickedParams
    * @property {string} businessLocation - 2-letter country code of location selected by a user
    * @property {string} ctaType - yes/no/learn_more_cbd/learn_more_prohibited/back/close
    * @property {GUID} msid - null
    * @property {string} origin - place where user clicks on cta
    * @property {string} pageType - accept_payments / prohibited_products
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - CTA at Accept  Payments page clicked. Evid: 240.
     * Event description: Merchant - CTA at Prohibited products page clicked.
    
     * businessLocation - Type: string. Desc: 2-letter country code of location selected by a user
     *
     * ctaType - Type: string. Desc: yes/no/learn_more_cbd/learn_more_prohibited/back/close
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: place where user clicks on cta
     *
     * pageType - Type: string. Desc: accept_payments / prohibited_products
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantCtaAtProhibitedProductsPageClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantCtaAtProhibitedProductsPageClicked = function (params) {
        return this.bi.log(__assign({ evid: 240 }, params));
    };
    /**
    * @typedef {Object} merchantWixPaymentsLbShownParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Wix Payments LB Shown. Evid: 168.
     * Event description: The LB is shown to Brazilian users, who doesn't have any payment settings (connected or selected payment methods), on opening Accept Payments tab (so they don't see full list of available payment methods).
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {merchantWixPaymentsLbShownParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantWixPaymentsLbShown = function (params) {
        return this.bi.log(__assign({ evid: 168 }, params));
    };
    /**
    * @typedef {Object} fastCheckoutButtonClickedParams
    * @property {string} cartId - cart id
    * @property {GUID} msid - null
    * @property {string} paymentProvider - payment_provider that chosen (PayPal, Wixpayments etc.)
    * @property {string} paymentmethod - payment method in provider (Venmo, PayPal Credit etc.)
    * @property {string} productid - product id where button was clicked
    * @property {string} sessionId - unique payment session to connect orders and trxs
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: fast checkout button clicked. Evid: 192.
     * Event description: when users click "Checkout with ..." on stores cart page. Any provider.
    
     * cartId - Type: string. Desc: cart id
     *
     * msid - Type: guid.
     *
     * paymentProvider - Type: string. Desc: payment_provider that chosen (PayPal, Wixpayments etc.)
     *
     * paymentmethod - Type: string. Desc: payment method in provider (Venmo, PayPal Credit etc.)
     *
     * productid - Type: string. Desc: product id where button was clicked
     *
     * sessionId - Type: string. Desc: unique payment session to connect orders and trxs
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {fastCheckoutButtonClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.fastCheckoutButtonClicked = function (params) {
        return this.bi.log(__assign({ evid: 192 }, params));
    };
    /**
    * @typedef {Object} upgradePopupPaymentTabInteractionParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} interaction - close/upgrade
    * @property {GUID} msid - null
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Complete Summary with Upgrade interaction. Evid: 151.
     * Event description: User interacts with Upgrade Pop Up which is shown after payment method is successfully connected: close or click Upgrade.
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * interaction - Type: string. Desc: close/upgrade
     *
     * msid - Type: guid.
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {upgradePopupPaymentTabInteractionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.upgradePopupPaymentTabInteraction = function (params) {
        return this.bi.log(__assign({ evid: 151 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickCancelManualReviewParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  Cancel  Manual Review. Evid: 431.
     * Event description: Employee click Cancel Manual Review.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickCancelManualReviewParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickCancelManualReview = function (params) {
        return this.bi.log(__assign({ evid: 431 }, params));
    };
    /**
    * @typedef {Object} boSitePageUserDrawerClickOnUmParams
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {Url} url - user manager url
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page user drawer click on UM. Evid: 406.
     * Event description: Employee click open in User Manager.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * url - Type: url. Desc: user manager url
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {boSitePageUserDrawerClickOnUmParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageUserDrawerClickOnUm = function (params) {
        return this.bi.log(__assign({ evid: 406 }, params));
    };
    /**
    * @typedef {Object} wixCodePaymentInitializationCompletedParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id (cashier)
    * @property {number} duration - loading time in miliseconds from buyer activity to page started loading
    * @property {string} errorDesc - error details
    * @property {string} merchantDefinedFields - buyer details, specified by merchant
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {boolean} showThankYouPage - merchant enables thank you page
    * @property {boolean} status - creation status: true / false
    * @property {boolean} termsAndConditions - true if shown, false is not shown
    * @property {boolean} thunderbolt - if loading was from thunderbolt then TRUE
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Wix Code Payment - Initialization completed. Evid: 209.
     * Event description: Payment Initialization completed.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id (cashier)
     *
     * duration - Type: numeric. Desc: loading time in miliseconds from buyer activity to page started loading
     *
     * errorDesc - Type: string. Desc: error details
     *
     * merchantDefinedFields - Type: string. Desc: buyer details, specified by merchant
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * showThankYouPage - Type: bool. Desc: merchant enables thank you page
     *
     * status - Type: bool. Desc: creation status: true / false
     *
     * termsAndConditions - Type: bool. Desc: true if shown, false is not shown
     *
     * thunderbolt - Type: bool. Desc: if loading was from thunderbolt then TRUE
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {wixCodePaymentInitializationCompletedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wixCodePaymentInitializationCompleted = function (params) {
        return this.bi.log(__assign({ evid: 209 }, params));
    };
    /**
    * @typedef {Object} installmentBannerLoadFinishedParams
    * @property {string} app_id - app id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - null
    * @property {string} offerId - offers that was shown ( array)
    * @property {string} productId - product id
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: installment banner load finished. Evid: 258.
     * Event description: start loading widget with data about installments ( Afterpay, laybuy, etc).
    
     * app_id - Type: string. Desc: app id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid.
     *
     * offerId - Type: string. Desc: offers that was shown ( array)
     *
     * productId - Type: string. Desc: product id
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {installmentBannerLoadFinishedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.installmentBannerLoadFinished = function (params) {
        return this.bi.log(__assign({ evid: 258 }, params));
    };
    /**
    * @typedef {Object} checkoutValidationErrorsParams
    * @property {GUID} appId - vertical ID
    * @property {string} errorMessage - Error message/localization key that was shown
    * @property {string} fieldName - Field type/name
    * @property {string} fieldValue - Data that was entered and failed validation
    * @property {GUID} msid - null
    * @property {string} paymentMethod - paymentMethod
    * @property {string} validValue - Validation rule/desired value
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout validation errors. Evid: 197.
     * Event description: Send BI event if UI validation of checkout mandatory fields fails.
    
     * appId - Type: guid. Desc: vertical ID
     *
     * errorMessage - Type: string. Desc: Error message/localization key that was shown
     *
     * fieldName - Type: string. Desc: Field type/name
     *
     * fieldValue - Type: string. Desc: Data that was entered and failed validation
     *
     * msid - Type: guid.
     *
     * paymentMethod - Type: string. Desc: paymentMethod
     *
     * validValue - Type: string. Desc: Validation rule/desired value
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {checkoutValidationErrorsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkoutValidationErrors = function (params) {
        return this.bi.log(__assign({ evid: 197 }, params));
    };
    /**
    * @typedef {Object} merchantCompleteSetUpClickedParams
    * @property {GUID} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} origin - payment page / autoonboarding / active on checkout
    * @property {string} paymentCategory - creditCard,paypal
    * @property {string} paymentProvider - stripe,paypal,eWay
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Complete Set-up clicked. Evid: 131.
     * Event description: Merchant-click complete setup.
    
     * appId - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: payment page / autoonboarding / active on checkout
     *
     * paymentCategory - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string. Desc: stripe,paypal,eWay
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantCompleteSetUpClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantCompleteSetUpClicked = function (params) {
        return this.bi.log(__assign({ evid: 131 }, params));
    };
    /**
    * @typedef {Object} myWalletCreditCardSetPrimaryClickedParams
    * @property {string} cardId - card_id
    * @property {boolean} isRetry - true if it's retry
    * @property {GUID} member_id - -
    * @property {GUID} memberId - member_id
    * @property {GUID} msid - msid
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - visitorId
    **/
    /**
     * Name: My Wallet - Credit Card set primary clicked. Evid: 225.
     * Event description: Logged in member confirms setting credit card as primary one.
    
     * cardId - Type: string. Desc: card_id
     *
     * isRetry - Type: bool. Desc: true if it's retry
     *
     * member_id - Type: guid. Desc: -
     *
     * memberId - Type: guid. Desc: member_id
     *
     * msid - Type: guid. Desc: msid
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid. Desc: visitorId
     * @param {myWalletCreditCardSetPrimaryClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.myWalletCreditCardSetPrimaryClicked = function (params) {
        return this.bi.log(__assign({ evid: 225 }, params));
    };
    /**
    * @typedef {Object} merchantManageAccountClickedParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} avalableCategory - available payment methods
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - connected payment methods (credit card etc.)
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Manage Account clicked. Evid: 118.
     * Event description: Click manage in Payment Methods Page.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * avalableCategory - Type: string. Desc: available payment methods
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: connected payment methods (credit card etc.)
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantManageAccountClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantManageAccountClicked = function (params) {
        return this.bi.log(__assign({ evid: 118 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickXRefundPayoutParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  [x]  Refund Payout. Evid: 428.
     * Event description: Employee click   [x]  Refund Payout.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickXRefundPayoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickXRefundPayout = function (params) {
        return this.bi.log(__assign({ evid: 428 }, params));
    };
    /**
    * @typedef {Object} merchantViewWixPaymentsNotificationsParams
    * @property {string} account_id - Wix Payments account_id
    * @property {GUID} msid - msid
    * @property {string} notificationType - COMPLIANCE_NOT_FINISHED_V4, etc
    * @property {string} paymentCategory - creditCard, applePay, POS
    * @property {string} paymentProvider - com.wix.wixpay.us
    * @property {string} platformName - null(desktop)/oneApp/partnets etc
    * @property {GUID} visitorId - visitorid
    **/
    /**
     * Name: Merchant - View Wix Payments Notifications. Evid: 290.
     * Event description: Merchant saw Wix Payments Notifications (Complete your setup to get verified, Your account is suspended, etc).
    
     * account_id - Type: string. Desc: Wix Payments account_id
     *
     * msid - Type: guid. Desc: msid
     *
     * notificationType - Type: string. Desc: COMPLIANCE_NOT_FINISHED_V4, etc
     *
     * paymentCategory - Type: string. Desc: creditCard, applePay, POS
     *
     * paymentProvider - Type: string. Desc: com.wix.wixpay.us
     *
     * platformName - Type: string. Desc: null(desktop)/oneApp/partnets etc
     *
     * visitorId - Type: guid. Desc: visitorid
     * @param {merchantViewWixPaymentsNotificationsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantViewWixPaymentsNotifications = function (params) {
        return this.bi.log(__assign({ evid: 290 }, params));
    };
    /**
    * @typedef {Object} wixCodeCheckOutBuyerViewsOrderDetailsParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id (cashier)
    * @property {GUID} cashierInstanceId - cashier_instance_id
    * @property {string} direction - NOT IN USE: button name (incl. close)
    * @property {number} duration - NOT IN USE: loading time in miliseconds
    * @property {string} errorDesc - NOT IN USE: error details
    * @property {string} errorType - NOT IN USE: generic, input
    * @property {string} merchantDefinedFields - buyer details, specified by merchant
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} page - name of the page
    * @property {string} pageFrom - NOT IN USE: page buyer is redirected from
    * @property {string} pageTo - NOT IN USE: page buyer will be navigated to
    * @property {string} paymentMethodsAvailable - list of available payment methods
    * @property {string} paymentMethodSelected - payment method selected if known
    * @property {string} selectedCountry - country chosen by buyer
    * @property {boolean} showThankYouPage - merchant enables thank you page
    * @property {string} status - NOT IN USE: transaction status for thank you page
    * @property {boolean} termsAndConditions - true if shown, false is not shown
    * @property {boolean} thunderbolt - if loading was from thunderbolt then TRUE
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Wix Code Checkout - Buyer views Order details. Evid: 204.
     * Event description: Wix Code Check out - Buyer views Order details.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id (cashier)
     *
     * cashierInstanceId - Type: guid. Desc: cashier_instance_id
     *
     * direction - Type: string. Desc: NOT IN USE: button name (incl. close)
     *
     * duration - Type: numeric. Desc: NOT IN USE: loading time in miliseconds
     *
     * errorDesc - Type: string. Desc: NOT IN USE: error details
     *
     * errorType - Type: string. Desc: NOT IN USE: generic, input
     *
     * merchantDefinedFields - Type: string. Desc: buyer details, specified by merchant
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * page - Type: string. Desc: name of the page
     *
     * pageFrom - Type: string. Desc: NOT IN USE: page buyer is redirected from
     *
     * pageTo - Type: string. Desc: NOT IN USE: page buyer will be navigated to
     *
     * paymentMethodsAvailable - Type: string. Desc: list of available payment methods
     *
     * paymentMethodSelected - Type: string. Desc: payment method selected if known
     *
     * selectedCountry - Type: string. Desc: country chosen by buyer
     *
     * showThankYouPage - Type: bool. Desc: merchant enables thank you page
     *
     * status - Type: string. Desc: NOT IN USE: transaction status for thank you page
     *
     * termsAndConditions - Type: bool. Desc: true if shown, false is not shown
     *
     * thunderbolt - Type: bool. Desc: if loading was from thunderbolt then TRUE
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {wixCodeCheckOutBuyerViewsOrderDetailsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wixCodeCheckOutBuyerViewsOrderDetails = function (params) {
        return this.bi.log(__assign({ evid: 204 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickXUnsuspendAccountParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  [x] unsuspend account. Evid: 420.
     * Event description: Employee click   [x] unsuspend account.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickXUnsuspendAccountParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickXUnsuspendAccount = function (params) {
        return this.bi.log(__assign({ evid: 420 }, params));
    };
    /**
    * @typedef {Object} merchantActivateProviderOnCheckOutPopUpShownParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} origin - active on check out
    * @property {string} paymentCategory - payment_category
    * @property {string} paymentProvider - payment_provider
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Activate provider on check-out pop-up shown. Evid: 173.
     * Event description: When user has completed APM account and tries to make it visible on a check-out by turning on toggle, Activate pop-up is shown.
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: active on check out
     *
     * paymentCategory - Type: string. Desc: payment_category
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {merchantActivateProviderOnCheckOutPopUpShownParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantActivateProviderOnCheckOutPopUpShown = function (params) {
        return this.bi.log(__assign({ evid: 173 }, params));
    };
    /**
    * @typedef {Object} boletoBankLoginParams
    * @property {number} amountLong - amount
    * @property {string} bankName - Choosed bank
    * @property {DateTime} due_date - due_date on boleto
    * @property {GUID} msid - null
    * @property {string} orderSnapshotId - Cashier order snapshot id
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Boleto bakn_login. Evid: 233.
     * Event description: When User choose bank and click to login.
    
     * amountLong - Type: numeric. Desc: amount
     *
     * bankName - Type: string. Desc: Choosed bank
     *
     * due_date - Type: datetime. Desc: due_date on boleto
     *
     * msid - Type: guid.
     *
     * orderSnapshotId - Type: string. Desc: Cashier order snapshot id
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boletoBankLoginParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boletoBankLogin = function (params) {
        return this.bi.log(__assign({ evid: 233 }, params));
    };
    /**
    * @typedef {Object} paymentDashboardTransactionSelectedParams
    * @property {string} action - expand / collapse
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} transactionId - transaction_id
    * @property {string} transactionStatus - current transaction status
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Payment Dashboard - transaction selected. Evid: 160.
     * Event description: user selects transaction to view details.
    
     * action - Type: string. Desc: expand / collapse
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * transactionId - Type: guid. Desc: transaction_id
     *
     * transactionStatus - Type: string. Desc: current transaction status
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {paymentDashboardTransactionSelectedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paymentDashboardTransactionSelected = function (params) {
        return this.bi.log(__assign({ evid: 160 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickCancelRefundPayoutParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  Cancel   Refund Payout. Evid: 427.
     * Event description: Employee click Cancel   Refund Payout.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickCancelRefundPayoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickCancelRefundPayout = function (params) {
        return this.bi.log(__assign({ evid: 427 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnSupportedProvidersListParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant-click on supported Providers List. Evid: 139.
     * Event description: Merchant-click on supported Providers List in the add more payment methods..
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantClickOnSupportedProvidersListParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnSupportedProvidersList = function (params) {
        return this.bi.log(__assign({ evid: 139 }, params));
    };
    /**
    * @typedef {Object} merchantConnectMeClickedParams
    * @property {GUID} appId - cashier app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} businessLocation - 2-letter country code of location selected by a user
    * @property {string} connectionType - auto/manual - connection type for each of defined providers, according to categories order, separated by comma
    * @property {string} emailStatus - default/changed/not required - tells user changed default (wix) email to create deferred account
    * @property {boolean} isAdditionalStep - false if additional screen for confirming emails wasn't shown; else true; null for is_first = false
    * @property {boolean} isFirst - true = if connection was made from initial page (with no connected pm)
    * @property {GUID} msid - msid
    * @property {string} pageType - page name
    * @property {string} paymentProvider - list of providers, defined as default - for each category, according to categories order, separated by comma
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {string} selectedValue - list of categories, selected by a user to connect, separated by comma
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Connect Me clicked. Evid: 128.
     * Event description: Merchant clicks connect me in smartOB funnel (welcome page or page with existing connections).
    
     * appId - Type: guid. Desc: cashier app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * businessLocation - Type: string. Desc: 2-letter country code of location selected by a user
     *
     * connectionType - Type: string. Desc: auto/manual - connection type for each of defined providers, according to categories order, separated by comma
     *
     * emailStatus - Type: string. Desc: default/changed/not required - tells user changed default (wix) email to create deferred account
     *
     * isAdditionalStep - Type: bool. Desc: false if additional screen for confirming emails wasn't shown; else true; null for is_first = false
     *
     * isFirst - Type: bool. Desc: true = if connection was made from initial page (with no connected pm)
     *
     * msid - Type: guid. Desc: msid
     *
     * pageType - Type: string. Desc: page name
     *
     * paymentProvider - Type: string. Desc: list of providers, defined as default - for each category, according to categories order, separated by comma
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * selectedValue - Type: string. Desc: list of categories, selected by a user to connect, separated by comma
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantConnectMeClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantConnectMeClicked = function (params) {
        return this.bi.log(__assign({ evid: 128 }, params));
    };
    /**
    * @typedef {Object} upgradePopupPaymentTabShownParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Complete Summary with Upgrade shown. Evid: 150.
     * Event description: Cashier Upgrade Pop Up is shown to user after payment method is successfully connected.
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {upgradePopupPaymentTabShownParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.upgradePopupPaymentTabShown = function (params) {
        return this.bi.log(__assign({ evid: 150 }, params));
    };
    /**
    * @typedef {Object} spbShippingMethodNotAcceptedParams
    * @property {number} amountLong - new amount ( * 100 000)
    * @property {GUID} appInstanceId - vertical instance id
    * @property {string} currency - new value
    * @property {string} externalOrderId - provider order id // for SPB = payPal order id
    * @property {GUID} msid - site id
    * @property {string} paymentMethod - new method, when method was changed
    * @property {string} sessionId - unique payment session to connect orders and trxs
    * @property {GUID} visitorId - visitor id
    **/
    /**
     * Name: SPB shipping/method not accepted. Evid: 217.
     * Event description: if Shipping addres is not OK.
    
     * amountLong - Type: numeric. Desc: new amount ( * 100 000)
     *
     * appInstanceId - Type: guid. Desc: vertical instance id
     *
     * currency - Type: string. Desc: new value
     *
     * externalOrderId - Type: string. Desc: provider order id // for SPB = payPal order id
     *
     * msid - Type: guid. Desc: site id
     *
     * paymentMethod - Type: string. Desc: new method, when method was changed
     *
     * sessionId - Type: string. Desc: unique payment session to connect orders and trxs
     *
     * visitorId - Type: guid. Desc: visitor id
     * @param {spbShippingMethodNotAcceptedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.spbShippingMethodNotAccepted = function (params) {
        return this.bi.log(__assign({ evid: 217 }, params));
    };
    /**
    * @typedef {Object} merchantClickSaveEmailOnSmartObParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {boolean} changedEmail - true/false
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant-click save email on smart OB. Evid: 136.
     * Event description: Merchant-click on save email on smart OB.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * changedEmail - Type: bool. Desc: true/false
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantClickSaveEmailOnSmartObParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickSaveEmailOnSmartOb = function (params) {
        return this.bi.log(__assign({ evid: 136 }, params));
    };
    /**
    * @typedef {Object} merchantThirdPartyCcProvidersPageShowedParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - null
    * @property {string} paymentProvider - Stripe, Square, Braintree
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Third Party CC Providers page showed. Evid: 251.
     * Event description: Third Party CC Providers page showed.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid.
     *
     * paymentProvider - Type: string. Desc: Stripe, Square, Braintree
     *
     * visitorId - Type: guid.
     * @param {merchantThirdPartyCcProvidersPageShowedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantThirdPartyCcProvidersPageShowed = function (params) {
        return this.bi.log(__assign({ evid: 251 }, params));
    };
    /**
    * @typedef {Object} merchantManagePageLoadStartParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - null
    * @property {GUID} msid - null
    * @property {string} paymentMethod - null
    * @property {string} paymentProvider - stripe,paypal,eWay
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Manage page Load Start. Evid: 245.
    
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid.
     *
     * msid - Type: guid.
     *
     * paymentMethod - Type: string.
     *
     * paymentProvider - Type: string. Desc: stripe,paypal,eWay
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantManagePageLoadStartParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantManagePageLoadStart = function (params) {
        return this.bi.log(__assign({ evid: 245 }, params));
    };
    /**
    * @typedef {Object} prohibitedProductsPageWasShownParams
    * @property {string} businessLocation - null
    * @property {GUID} msid - null
    * @property {string} origin - add_payment_method/connect_me/change_provider
    * @property {string} pageType - prohibited_products, products_list
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {string} selectedValue - list of categories, selected by a user to connect, separated by comma
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Prohibited products page was shown. Evid: 239.
     * Event description: Prohibited products page was shown to user after a click on Connect Wix Payment.
    
     * businessLocation - Type: string.
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: add_payment_method/connect_me/change_provider
     *
     * pageType - Type: string. Desc: prohibited_products, products_list
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * selectedValue - Type: string. Desc: list of categories, selected by a user to connect, separated by comma
     *
     * visitorId - Type: guid.
     * @param {prohibitedProductsPageWasShownParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.prohibitedProductsPageWasShown = function (params) {
        return this.bi.log(__assign({ evid: 239 }, params));
    };
    /**
    * @typedef {Object} completeProviderSetupPopupShownParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - MSID
    * @property {string} origin - autoonboarding / add provider / active on check out
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - VisitoID
    **/
    /**
     * Name: Merchant - Complete Summary w/o Upgrade shown. Evid: 152.
     * Event description: To be sent when at least one payment method doesn't connect automatically.
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: MSID
     *
     * origin - Type: string. Desc: autoonboarding / add provider / active on check out
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid. Desc: VisitoID
     * @param {completeProviderSetupPopupShownParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.completeProviderSetupPopupShown = function (params) {
        return this.bi.log(__assign({ evid: 152 }, params));
    };
    /**
    * @typedef {Object} checkOutNoAvailableProvidersRefreshClickedParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} buyerComponent - buyer_component
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderId - order id
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} paymentCategory - Offline payment, MercadoPago, Paypal, Credit card
    * @property {string} paymentProvider - payment_provider
    * @property {boolean} refreshResult - true if payment component was loaded
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout - No available providers Refresh clicked. Evid: 175.
     * Event description: When buyer comes to Payment Component on a check-out, and all of connected providers are disabled, we show notification to a buyer and buyer clicks Refresh.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * buyerComponent - Type: string. Desc: buyer_component
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderId - Type: string. Desc: order id
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * paymentCategory - Type: string. Desc: Offline payment, MercadoPago, Paypal, Credit card
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * refreshResult - Type: bool. Desc: true if payment component was loaded
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {checkOutNoAvailableProvidersRefreshClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkOutNoAvailableProvidersRefreshClicked = function (params) {
        return this.bi.log(__assign({ evid: 175 }, params));
    };
    /**
    * @typedef {Object} boletoPopUpOpenedParams
    * @property {number} amountLong - amount
    * @property {DateTime} due_date - due_date on boleto
    * @property {GUID} msid - null
    * @property {string} orderSnapshotId - Cashier order snapshot id
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Boleto PopUp opened. Evid: 235.
     * Event description: When User choose pay with boleto and click place order.
    
     * amountLong - Type: numeric. Desc: amount
     *
     * due_date - Type: datetime. Desc: due_date on boleto
     *
     * msid - Type: guid.
     *
     * orderSnapshotId - Type: string. Desc: Cashier order snapshot id
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boletoPopUpOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boletoPopUpOpened = function (params) {
        return this.bi.log(__assign({ evid: 235 }, params));
    };
    /**
    * @typedef {Object} merchantUserClickedCtaOnModalParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} cta - keep / disable
    * @property {string} modal_name - leave_without_changes/ confirm_disable_payment_method
    * @property {GUID} msid - null
    * @property {string} page - disconnect / connect other
    * @property {string} paymentCategory - currently connected category
    * @property {string} paymentProvider - currently connected provider
    * @property {string} platformName - desktop/oneApp etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - User clicked cta on modal. Evid: 249.
     * Event description: User clicked cta on modal on accept_payments / manage_page / third_party_cc_providers.
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * cta - Type: string. Desc: keep / disable
     *
     * modal_name - Type: string. Desc: leave_without_changes/ confirm_disable_payment_method
     *
     * msid - Type: guid.
     *
     * page - Type: string. Desc: disconnect / connect other
     *
     * paymentCategory - Type: string. Desc: currently connected category
     *
     * paymentProvider - Type: string. Desc: currently connected provider
     *
     * platformName - Type: string. Desc: desktop/oneApp etc
     *
     * visitorId - Type: guid.
     * @param {merchantUserClickedCtaOnModalParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantUserClickedCtaOnModal = function (params) {
        return this.bi.log(__assign({ evid: 249 }, params));
    };
    /**
    * @typedef {Object} merchantSetUpAccountClickedParams
    * @property {GUID} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} origin - autoconnect / add provider / set up / set up to activate / change provider
    * @property {string} paymentCategory - Credit Card,PayPal,Mercado Pago, Offline
    * @property {string} paymentProvider - payment_provider
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - -
    **/
    /**
     * Name: Merchant - Set-up account clicked. Evid: 153.
     * Event description: Merchant click on setup account to activate in smart ob - different sources.
    
     * appId - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: autoconnect / add provider / set up / set up to activate / change provider
     *
     * paymentCategory - Type: string. Desc: Credit Card,PayPal,Mercado Pago, Offline
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid. Desc: -
     * @param {merchantSetUpAccountClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantSetUpAccountClicked = function (params) {
        return this.bi.log(__assign({ evid: 153 }, params));
    };
    /**
    * @typedef {Object} wixCodeCheckOutPageLoadedParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id (cashier)
    * @property {GUID} cashierInstanceId - cashier_instance_id
    * @property {string} direction - NOT IN USE: button name
    * @property {number} duration - loading time in miliseconds
    * @property {string} errorDesc - NOT IN USE: error details
    * @property {string} errorType - NOT IN USE: generic, input
    * @property {number} fullDuration - full duration from buyer intent to finish loaded
    * @property {string} merchantDefinedFields - buyer details, specified by merchant
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} page - name of the page
    * @property {string} pageFrom - page buyer is redirected from
    * @property {string} pageTo - NOT IN USE: page buyer will be navigated to
    * @property {string} paymentMethodsAvailable - list of available payment methods
    * @property {string} paymentMethodSelected - payment method selected if known
    * @property {string} selectedCountry - country chosen by buyer
    * @property {boolean} showThankYouPage - merchant enables thank you page
    * @property {string} status - transaction status for thank you page
    * @property {boolean} termsAndConditions - true if shown, false is not shown
    * @property {boolean} thunderbolt - if loading was from thunderbolt then TRUE
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Wix Code Checkout - Page loaded. Evid: 201.
     * Event description: Wix Code Check out - Page loaded.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id (cashier)
     *
     * cashierInstanceId - Type: guid. Desc: cashier_instance_id
     *
     * direction - Type: string. Desc: NOT IN USE: button name
     *
     * duration - Type: numeric. Desc: loading time in miliseconds
     *
     * errorDesc - Type: string. Desc: NOT IN USE: error details
     *
     * errorType - Type: string. Desc: NOT IN USE: generic, input
     *
     * fullDuration - Type: numeric. Desc: full duration from buyer intent to finish loaded
     *
     * merchantDefinedFields - Type: string. Desc: buyer details, specified by merchant
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * page - Type: string. Desc: name of the page
     *
     * pageFrom - Type: string. Desc: page buyer is redirected from
     *
     * pageTo - Type: string. Desc: NOT IN USE: page buyer will be navigated to
     *
     * paymentMethodsAvailable - Type: string. Desc: list of available payment methods
     *
     * paymentMethodSelected - Type: string. Desc: payment method selected if known
     *
     * selectedCountry - Type: string. Desc: country chosen by buyer
     *
     * showThankYouPage - Type: bool. Desc: merchant enables thank you page
     *
     * status - Type: string. Desc: transaction status for thank you page
     *
     * termsAndConditions - Type: bool. Desc: true if shown, false is not shown
     *
     * thunderbolt - Type: bool. Desc: if loading was from thunderbolt then TRUE
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {wixCodeCheckOutPageLoadedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wixCodeCheckOutPageLoaded = function (params) {
        return this.bi.log(__assign({ evid: 201 }, params));
    };
    /**
    * @typedef {Object} paymentDashboardRemovedToastParams
    * @property {GUID} msid - site_id
    * @property {GUID} uuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Payment Dashboard removed toast. Evid: 196.
     * Event description: When users, who saw payment dashboard previously, goes to Accept Payment Tab we notify him(through toast) that place changes.
    
     * msid - Type: guid. Desc: site_id
     *
     * uuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {paymentDashboardRemovedToastParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paymentDashboardRemovedToast = function (params) {
        return this.bi.log(__assign({ evid: 196 }, params));
    };
    /**
    * @typedef {Object} merchantClickedOnCtaOnConnectPageParams
    * @property {GUID} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} cta - cancel or sign_in
    * @property {GUID} msid - null
    * @property {string} paymentCategory - creditCard,paypal
    * @property {string} paymentProvider - stripe,paypal,eWay
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant -  clicked on cta on connect page. Evid: 252.
     * Event description: Merchant-click complete setup.
    
     * appId - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * cta - Type: string. Desc: cancel or sign_in
     *
     * msid - Type: guid.
     *
     * paymentCategory - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string. Desc: stripe,paypal,eWay
     *
     * visitorId - Type: guid.
     * @param {merchantClickedOnCtaOnConnectPageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickedOnCtaOnConnectPage = function (params) {
        return this.bi.log(__assign({ evid: 252 }, params));
    };
    /**
    * @typedef {Object} merchantOaChoosePaymentMethodsClickedParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant OA - Choose Payment Methods clicked. Evid: 177.
     * Event description: Merchant clicks Choose Payment Methods on OA Accept Payments Welcome tab.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantOaChoosePaymentMethodsClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantOaChoosePaymentMethodsClicked = function (params) {
        return this.bi.log(__assign({ evid: 177 }, params));
    };
    /**
    * @typedef {Object} transaction3dsFormParams
    * @property {boolean} isFinished - true if page was success , false if not
    * @property {boolean} isOpened - true if page was open , false if closed
    * @property {GUID} msid - null
    * @property {GUID} orderId - order_id
    * @property {number} version3ds - 3DS version (1 or 2)
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Transaction 3ds form. Evid: 193.
     * Event description: when users click "Submit Order" and 3DS form was showed.
    
     * isFinished - Type: bool. Desc: true if page was success , false if not
     *
     * isOpened - Type: bool. Desc: true if page was open , false if closed
     *
     * msid - Type: guid.
     *
     * orderId - Type: guid. Desc: order_id
     *
     * version3ds - Type: numeric. Desc: 3DS version (1 or 2)
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {transaction3dsFormParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.transaction3dsForm = function (params) {
        return this.bi.log(__assign({ evid: 193 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickXManualReviewParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenantid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  [x]  Manual Review. Evid: 432.
     * Event description: Employee click   [x]  Manual Review.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenantid
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickXManualReviewParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickXManualReview = function (params) {
        return this.bi.log(__assign({ evid: 432 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickXProcessPayoutParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  [x] Process Payout. Evid: 424.
     * Event description: Employee click   [x]  Process Payout.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickXProcessPayoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickXProcessPayout = function (params) {
        return this.bi.log(__assign({ evid: 424 }, params));
    };
    /**
    * @typedef {Object} merchantObNavigationParams
    * @property {string} cta - back/see_more_options/choose_provider/connect_page
    * @property {GUID} msid - msid
    * @property {string} pageType - what page in the dashboard : accept_payments / more_payment_methods  / third_party_cc_providers
    * @property {string} paymentCategory - dependent from page where user located
    * @property {string} paymentProvider - dependent from page where user located
    * @property {string} platformName - desktop/oneApp etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - OB Navigation. Evid: 242.
     * Event description: Merchant-clicked
    “More Payment Methods”
    ”Third party credit / debit card providers”
    Back arrow on OB page.
    
     * cta - Type: string. Desc: back/see_more_options/choose_provider/connect_page
     *
     * msid - Type: guid. Desc: msid
     *
     * pageType - Type: string. Desc: what page in the dashboard : accept_payments / more_payment_methods  / third_party_cc_providers
     *
     * paymentCategory - Type: string. Desc: dependent from page where user located
     *
     * paymentProvider - Type: string. Desc: dependent from page where user located
     *
     * platformName - Type: string. Desc: desktop/oneApp etc
     *
     * visitorId - Type: guid.
     * @param {merchantObNavigationParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantObNavigation = function (params) {
        return this.bi.log(__assign({ evid: 242 }, params));
    };
    /**
    * @typedef {Object} spbErrorDuringStartInitializationCheckoutParams
    * @property {string} cartId - cart id
    * @property {string} errorReason - Error reason
    * @property {GUID} msid - msid
    * @property {string} paymentProvider - payment_provider that chosen (PayPal, Wixpayments etc.)
    * @property {string} paymentmethod - payment method in provider (Venmo, PayPal Credit etc.)
    * @property {string} sessionId - unique payment session to connect orders and trxs
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: SPB error during startInitializationCheckout. Evid: 211.
     * Event description: Smart Payment Button error during start Initialization Checkout (creating order on PayPal Failed or user is not premium). Send the reason in the event.
    
     * cartId - Type: string. Desc: cart id
     *
     * errorReason - Type: string. Desc: Error reason
     *
     * msid - Type: guid. Desc: msid
     *
     * paymentProvider - Type: string. Desc: payment_provider that chosen (PayPal, Wixpayments etc.)
     *
     * paymentmethod - Type: string. Desc: payment method in provider (Venmo, PayPal Credit etc.)
     *
     * sessionId - Type: string. Desc: unique payment session to connect orders and trxs
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {spbErrorDuringStartInitializationCheckoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.spbErrorDuringStartInitializationCheckout = function (params) {
        return this.bi.log(__assign({ evid: 211 }, params));
    };
    /**
    * @typedef {Object} myWalletCreditCardDeleteConfirmedParams
    * @property {string} cardId - card_id
    * @property {GUID} member_id - -
    * @property {GUID} memberId - member_id
    * @property {GUID} msid - msid
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: My Wallet - Credit Card delete confirmed. Evid: 223.
     * Event description: Logged in member confirms credit card removing from his wallet.
    
     * cardId - Type: string. Desc: card_id
     *
     * member_id - Type: guid. Desc: -
     *
     * memberId - Type: guid. Desc: member_id
     *
     * msid - Type: guid. Desc: msid
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {myWalletCreditCardDeleteConfirmedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.myWalletCreditCardDeleteConfirmed = function (params) {
        return this.bi.log(__assign({ evid: 223 }, params));
    };
    /**
    * @typedef {Object} merchantCancelChangeBusinessLocationParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} businessLocation - the country that the user selected
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} origin - seamless/classic
    * @property {string} platformName - desktop/oneApp etc
    * @property {string} type - first_entry/remove_pm/country_list
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - cancel change  business location. Evid: 134.
     * Event description: Merchant -cancel change  business location.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * businessLocation - Type: string. Desc: the country that the user selected
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * origin - Type: string. Desc: seamless/classic
     *
     * platformName - Type: string. Desc: desktop/oneApp etc
     *
     * type - Type: string. Desc: first_entry/remove_pm/country_list
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantCancelChangeBusinessLocationParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantCancelChangeBusinessLocation = function (params) {
        return this.bi.log(__assign({ evid: 134 }, params));
    };
    /**
    * @typedef {Object} expressCheckoutWidgetLoadingStartParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} currency - currency
    * @property {GUID} msid - null
    * @property {string} origin - page type where widget was loaded
    * @property {string} productId - product_id where widget is loaded
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Express checkout widget loading start. Evid: 261.
     * Event description: When express widget loading start.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * currency - Type: string. Desc: currency
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: page type where widget was loaded
     *
     * productId - Type: string. Desc: product_id where widget is loaded
     *
     * visitorId - Type: guid.
     * @param {expressCheckoutWidgetLoadingStartParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.expressCheckoutWidgetLoadingStart = function (params) {
        return this.bi.log(__assign({ evid: 261 }, params));
    };
    /**
    * @typedef {Object} transaction3dsFingerPrintParams
    * @property {boolean} isFinished - true if page was success , false if not
    * @property {boolean} isOpened - true if page was open , false if closed
    * @property {GUID} msid - null
    * @property {GUID} orderId - order_id
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Transaction 3ds FingerPrint. Evid: 194.
     * Event description: when users click "Submit Order" and FingerPrint collect was started.
    
     * isFinished - Type: bool. Desc: true if page was success , false if not
     *
     * isOpened - Type: bool. Desc: true if page was open , false if closed
     *
     * msid - Type: guid.
     *
     * orderId - Type: guid. Desc: order_id
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {transaction3dsFingerPrintParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.transaction3dsFingerPrint = function (params) {
        return this.bi.log(__assign({ evid: 194 }, params));
    };
    /**
    * @typedef {Object} merchantSwitchAccountClickedParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - Credit Card
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {string} stepNext - redirect / confirmation popup for trx / manaege popup
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Switch Account clicked. Evid: 176.
     * Event description: Merchant clicks on Switch Account on Accept Payments.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: Credit Card
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * stepNext - Type: string. Desc: redirect / confirmation popup for trx / manaege popup
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantSwitchAccountClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantSwitchAccountClicked = function (params) {
        return this.bi.log(__assign({ evid: 176 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickOnOpenInWpDashboardParams
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {Url} url - WP dashboard url
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click on Open in WP Dashboard. Evid: 416.
     * Event description: Employee click Open in WP Dashboard.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * url - Type: url. Desc: WP dashboard url
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickOnOpenInWpDashboardParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickOnOpenInWpDashboard = function (params) {
        return this.bi.log(__assign({ evid: 416 }, params));
    };
    /**
    * @typedef {Object} checkoutZipAutoFilledFieldsParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - null
    * @property {string} orderSnapshotId - PbW snapshot id
    * @property {string} value - List of fields that was filled by zip. Example "country" or "country, city, address""
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Checkout - ZipAutoFilled fields. Evid: 276.
     * Event description: list of fields that was filled by zip.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid.
     *
     * orderSnapshotId - Type: string. Desc: PbW snapshot id
     *
     * value - Type: string. Desc: List of fields that was filled by zip. Example "country" or "country, city, address""
     *
     * visitorId - Type: guid.
     * @param {checkoutZipAutoFilledFieldsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkoutZipAutoFilledFields = function (params) {
        return this.bi.log(__assign({ evid: 276 }, params));
    };
    /**
    * @typedef {Object} merchantSelectPaymentCategoryToConnectParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} origin - - not in use
    * @property {string} pageName - Payment Method_first page
    * @property {string} paymentCategory - Credit Card
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant-select payment category to connect. Evid: 137.
     * Event description: Merchant-select payment category to connect.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * origin - Type: string. Desc: - not in use
     *
     * pageName - Type: string. Desc: Payment Method_first page
     *
     * paymentCategory - Type: string. Desc: Credit Card
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantSelectPaymentCategoryToConnectParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantSelectPaymentCategoryToConnect = function (params) {
        return this.bi.log(__assign({ evid: 137 }, params));
    };
    /**
    * @typedef {Object} boSitePageTransactionDrawerOpenParams
    * @property {string} displayName - employee displayName
    * @property {number} loadTime - loadtime
    * @property {GUID} msid - msid
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page transaction drawer open. Evid: 408.
     * Event description: Employee open transaction drawer.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * loadTime - Type: numeric. Desc: loadtime
     *
     * msid - Type: guid. Desc: msid
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boSitePageTransactionDrawerOpenParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageTransactionDrawerOpen = function (params) {
        return this.bi.log(__assign({ evid: 408 }, params));
    };
    /**
    * @typedef {Object} merchantProvidersToConnectDefinedParams
    * @property {GUID} appId - cashier app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} businessLocation - 2-letter country code of location selected by a user
    * @property {string} connectionType - auto/manual - connection type for each of defined providers, according to categories order, separated by comma
    * @property {GUID} msid - msid
    * @property {string} paymentProvider - list of providers, defined as default - for each category, according to categories order, separated by comma
    * @property {string} selectedValue - list of categories, selected by a user to connect, separated by comma
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Providers to Connect Defined. Evid: 185.
     * Event description: Additional event, that describes connection type for providers, defined as default for each of selected categories.
    
     * appId - Type: guid. Desc: cashier app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * businessLocation - Type: string. Desc: 2-letter country code of location selected by a user
     *
     * connectionType - Type: string. Desc: auto/manual - connection type for each of defined providers, according to categories order, separated by comma
     *
     * msid - Type: guid. Desc: msid
     *
     * paymentProvider - Type: string. Desc: list of providers, defined as default - for each category, according to categories order, separated by comma
     *
     * selectedValue - Type: string. Desc: list of categories, selected by a user to connect, separated by comma
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantProvidersToConnectDefinedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantProvidersToConnectDefined = function (params) {
        return this.bi.log(__assign({ evid: 185 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnChangeProviderOnThePaymentMethodPageParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {boolean} isConnect - true if payment method is connected, false if selected
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - Credit Card
    * @property {string} paymentProvider - current payment provider name
    * @property {string} platformName - desktop/oneApp etc
    * @property {string} source - change provider/ list from +add
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - click on change provider on the payment method page. Evid: 140.
     * Event description: Merchant-click on change provider on the payment method page. It can be happens from the connected provider or from the link to list providers in +add, if it is add and not change we will get null on payment provider and payment category..
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * isConnect - Type: bool. Desc: true if payment method is connected, false if selected
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: Credit Card
     *
     * paymentProvider - Type: string. Desc: current payment provider name
     *
     * platformName - Type: string. Desc: desktop/oneApp etc
     *
     * source - Type: string. Desc: change provider/ list from +add
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantClickOnChangeProviderOnThePaymentMethodPageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnChangeProviderOnThePaymentMethodPage = function (params) {
        return this.bi.log(__assign({ evid: 140 }, params));
    };
    /**
    * @typedef {Object} boSitePageUserDrawerOpenedParams
    * @property {string} displayName - employee displayName
    * @property {number} loadTime - loadtime
    * @property {GUID} msid - msid
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - visitor
    **/
    /**
     * Name: [BO] Site Page user drawer opened. Evid: 434.
     * Event description: Employee open user drawer.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * loadTime - Type: numeric. Desc: loadtime
     *
     * msid - Type: guid. Desc: msid
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid. Desc: visitor
     * @param {boSitePageUserDrawerOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageUserDrawerOpened = function (params) {
        return this.bi.log(__assign({ evid: 434 }, params));
    };
    /**
    * @typedef {Object} merchantBusinessLocationShowHideModalWindowParams
    * @property {string} businessLocation - country on the Accept Payment tab
    * @property {GUID} msid - null
    * @property {string} paymentMethod - already connected paymentMethods or null
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {string} type - first_entry/remove_pm
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Business Location show/hide modal window. Evid: 238.
     * Event description: Merchant-click on country on the Payment first page of the smart onboarding.
    
     * businessLocation - Type: string. Desc: country on the Accept Payment tab
     *
     * msid - Type: guid.
     *
     * paymentMethod - Type: string. Desc: already connected paymentMethods or null
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * type - Type: string. Desc: first_entry/remove_pm
     *
     * visitorId - Type: guid.
     * @param {merchantBusinessLocationShowHideModalWindowParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantBusinessLocationShowHideModalWindow = function (params) {
        return this.bi.log(__assign({ evid: 238 }, params));
    };
    /**
    * @typedef {Object} installmentBannerClickedMoreInfoParams
    * @property {string} app_id - app id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - null
    * @property {string} paymentProvider - name of provider
    * @property {string} productId - product id
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: installment banner clicked "more info". Evid: 259.
     * Event description: start loading widget with data about installments ( Afterpay, laybuy, etc).
    
     * app_id - Type: string. Desc: app id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid.
     *
     * paymentProvider - Type: string. Desc: name of provider
     *
     * productId - Type: string. Desc: product id
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {installmentBannerClickedMoreInfoParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.installmentBannerClickedMoreInfo = function (params) {
        return this.bi.log(__assign({ evid: 259 }, params));
    };
    /**
    * @typedef {Object} merchantOaNoProvidersAvailableParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} businessLocation - the country that the user selected
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant OA - No providers available. Evid: 178.
     * Event description: When Merchants goes from / select business location with no payment providers, allowing automatically connect, this pop up is shown (only OA).
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * businessLocation - Type: string. Desc: the country that the user selected
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantOaNoProvidersAvailableParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantOaNoProvidersAvailable = function (params) {
        return this.bi.log(__assign({ evid: 178 }, params));
    };
    /**
    * @typedef {Object} checkOutSubmitOrderParams
    * @property {GUID} aid - visitor_id from aid
    * @property {string} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} buyerComponent - -
    * @property {GUID} cardId - -
    * @property {GUID} creditCardId - for previously saved credit cards
    * @property {string} errorDesc - where is the error
    * @property {boolean} forcedFullRedirectInIAB - Whether full-redirect was forced in InAppBrowser instead of new tab/window strategy
    * @property {GUID} memberId - null if visitor is not logged in
    * @property {GUID} membershipId -
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} orderId - vertical order id
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} paymentCategory - payment_category
    * @property {string} paymentMethodType - For credit card- credit card type:jcb
    mastercard
    discover
    isracard
    maestro
    visa
    amex
    diners
    * @property {string} paymentProvider - stripe,paypal,square
    * @property {string} redirectTarget - EMBEDDED - modal, NEW_WINDOW - new tab/window, SAME_WINDOW - full redirect
    * @property {boolean} saveCreditCard - true if user choose to save CC
    * @property {boolean} status - pass client validation
    * @property {GUID} transactionId - transaction_id
    * @property {GUID} visitorId - visitor_id ; starting from June-4th 2020 the value is aid
    **/
    /**
     * Name: Checkout - Submit Order. Evid: 104.
     * Event description: The visitor clicked on 'Submit order'.
    
     * aid - Type: guid. Desc: visitor_id from aid
     *
     * appId - Type: string. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * buyerComponent - Type: string. Desc: -
     *
     * cardId - Type: guid. Desc: -
     *
     * creditCardId - Type: guid. Desc: for previously saved credit cards
     *
     * errorDesc - Type: string. Desc: where is the error
     *
     * forcedFullRedirectInIAB - Type: bool. Desc: Whether full-redirect was forced in InAppBrowser instead of new tab/window strategy
     *
     * memberId - Type: guid. Desc: null if visitor is not logged in
     *
     * membershipId - Type: guid.
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderId - Type: guid. Desc: vertical order id
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * paymentCategory - Type: string. Desc: payment_category
     *
     * paymentMethodType - Type: string. Desc: For credit card- credit card type:jcb
    mastercard
    discover
    isracard
    maestro
    visa
    amex
    diners
     *
     * paymentProvider - Type: string. Desc: stripe,paypal,square
     *
     * redirectTarget - Type: string. Desc: EMBEDDED - modal, NEW_WINDOW - new tab/window, SAME_WINDOW - full redirect
     *
     * saveCreditCard - Type: bool. Desc: true if user choose to save CC
     *
     * status - Type: bool. Desc: pass client validation
     *
     * transactionId - Type: guid. Desc: transaction_id
     *
     * visitorId - Type: guid. Desc: visitor_id ; starting from June-4th 2020 the value is aid
     * @param {checkOutSubmitOrderParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkOutSubmitOrder = function (params) {
        return this.bi.log(__assign({ evid: 104 }, params));
    };
    /**
    * @typedef {Object} boletoPopUpClosedParams
    * @property {number} amountLong - amount
    * @property {boolean} close_button - true if button close ,false if [x]
    * @property {DateTime} due_date - due_date on boleto
    * @property {GUID} msid - null
    * @property {string} orderSnapshotId - Cashier order snapshot id
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Boleto PopUp closed. Evid: 236.
     * Event description: When User close boleto popup.
    
     * amountLong - Type: numeric. Desc: amount
     *
     * close_button - Type: bool. Desc: true if button close ,false if [x]
     *
     * due_date - Type: datetime. Desc: due_date on boleto
     *
     * msid - Type: guid.
     *
     * orderSnapshotId - Type: string. Desc: Cashier order snapshot id
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boletoPopUpClosedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boletoPopUpClosed = function (params) {
        return this.bi.log(__assign({ evid: 236 }, params));
    };
    /**
    * @typedef {Object} financialToolsOpenPaymentsDashboardParams
    * @property {GUID} msid - null
    * @property {string} selectedValue - empty state 1 / empty state 2/ ... / Payments Overview
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Financial Tools - open Payments Dashboard. Evid: 191.
     * Event description: Merchant opened Payments Dashboard in Financial Tools.
    
     * msid - Type: guid.
     *
     * selectedValue - Type: string. Desc: empty state 1 / empty state 2/ ... / Payments Overview
     *
     * visitorId - Type: guid.
     * @param {financialToolsOpenPaymentsDashboardParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.financialToolsOpenPaymentsDashboard = function (params) {
        return this.bi.log(__assign({ evid: 191 }, params));
    };
    /**
    * @typedef {Object} merchantSaveInManageAccountClickedParams
    * @property {GUID} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} oldValue - old field setting
    * @property {string} paymentCategory - creditCard,paypal
    * @property {string} paymentProvider - stripe,paypal,eWay
    * @property {string} platformName - desktop/oneApp etc
    * @property {string} selectedValue - list of additional provider settings e.g. PayPal Credit
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Save in Manage Account clicked. Evid: 144.
     * Event description: Merchant-click complete setup.
    
     * appId - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * oldValue - Type: string. Desc: old field setting
     *
     * paymentCategory - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string. Desc: stripe,paypal,eWay
     *
     * platformName - Type: string. Desc: desktop/oneApp etc
     *
     * selectedValue - Type: string. Desc: list of additional provider settings e.g. PayPal Credit
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantSaveInManageAccountClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantSaveInManageAccountClicked = function (params) {
        return this.bi.log(__assign({ evid: 144 }, params));
    };
    /**
    * @typedef {Object} merchantClicksOnMakeTestTransactionParams
    * @property {string} bannerName - wix_payments_card_notification
    * @property {string} cta - make_test_transaction
    * @property {GUID} msid - msid
    * @property {string} pageType - page where banner was shown - accept_payment/manage_page etc
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - visitorid
    **/
    /**
     * Name: Merchant - clicks on Make Test Transaction. Evid: 286.
     * Event description: User clicks on 'Make Test Transaction' on the banner in order to be verified.
    
     * bannerName - Type: string. Desc: wix_payments_card_notification
     *
     * cta - Type: string. Desc: make_test_transaction
     *
     * msid - Type: guid. Desc: msid
     *
     * pageType - Type: string. Desc: page where banner was shown - accept_payment/manage_page etc
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid. Desc: visitorid
     * @param {merchantClicksOnMakeTestTransactionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClicksOnMakeTestTransaction = function (params) {
        return this.bi.log(__assign({ evid: 286 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnCountrySmartObParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {string} type - first_entry/remove_pm/country_list
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Business Location click. Evid: 132.
     * Event description: Merchant-click on country on the Payment first page of the smart onboarding.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * type - Type: string. Desc: first_entry/remove_pm/country_list
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantClickOnCountrySmartObParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnCountrySmartOb = function (params) {
        return this.bi.log(__assign({ evid: 132 }, params));
    };
    /**
    * @typedef {Object} merchantConfirmDisconnectClickedParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} cta - init_disconnect / ok / cancel
    * @property {string} interaction - null
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - Credit Card
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Disconnect clicked. Evid: 123.
     * Event description: Confirm disconnect- merchant is asked id he sure that he want to disconnect and click disconnect.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * cta - Type: string. Desc: init_disconnect / ok / cancel
     *
     * interaction - Type: string.
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: Credit Card
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantConfirmDisconnectClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantConfirmDisconnectClicked = function (params) {
        return this.bi.log(__assign({ evid: 123 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickManualReviewParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click Manual Review. Evid: 429.
     * Event description: Employee click Manual Review in account.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickManualReviewParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickManualReview = function (params) {
        return this.bi.log(__assign({ evid: 429 }, params));
    };
    /**
    * @typedef {Object} buyerPaymentsComponentLoadStartParams
    * @property {string} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} buyerComponent - defines new buyer component (null for old, 'react' for new one)
    * @property {number} duration - loading time in miliseconds
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} payWith - Payment method
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout - Buyer-Payments component  load start. Evid: 125.
     * Event description: Payments component  load start.
    
     * appId - Type: string. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * buyerComponent - Type: string. Desc: defines new buyer component (null for old, 'react' for new one)
     *
     * duration - Type: numeric. Desc: loading time in miliseconds
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * payWith - Type: string. Desc: Payment method
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {buyerPaymentsComponentLoadStartParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.buyerPaymentsComponentLoadStart = function (params) {
        return this.bi.log(__assign({ evid: 125 }, params));
    };
    /**
    * @typedef {Object} merchantGoToPaymentsDashboardClickedParams
    * @property {GUID} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} connectionStatus - active / suspended / else
    * @property {GUID} msid - msid
    * @property {string} origin - payment methods / dashboard
    * @property {string} paymentCategory - creditCard
    * @property {string} paymentProvider - wix.com.wixpay
    * @property {GUID} transactionId - null from payment methods
    * @property {string} transactionStatus - null from payment methods
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Go to Payments Dashboard clicked. Evid: 181.
     * Event description: Merchant clicks on  Go to Payments Dashboard (relevant for wix pay only).
    
     * appId - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * connectionStatus - Type: string. Desc: active / suspended / else
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: payment methods / dashboard
     *
     * paymentCategory - Type: string. Desc: creditCard
     *
     * paymentProvider - Type: string. Desc: wix.com.wixpay
     *
     * transactionId - Type: guid. Desc: null from payment methods
     *
     * transactionStatus - Type: string. Desc: null from payment methods
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantGoToPaymentsDashboardClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantGoToPaymentsDashboardClicked = function (params) {
        return this.bi.log(__assign({ evid: 181 }, params));
    };
    /**
    * @typedef {Object} pixModalOpenedParams
    * @property {number} amountLong - amount
    * @property {GUID} msid - msid
    * @property {string} orderSnapshotId - Cashier order snapshot id
    * @property {string} paymentMethodType - payment_method_type
    * @property {string} paymentProvider - Payment Provider
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Instant PM Modal opened. Evid: 287.
     * Event description: When User choose pay with PIX and click place order.
    
     * amountLong - Type: numeric. Desc: amount
     *
     * msid - Type: guid. Desc: msid
     *
     * orderSnapshotId - Type: string. Desc: Cashier order snapshot id
     *
     * paymentMethodType - Type: string. Desc: payment_method_type
     *
     * paymentProvider - Type: string. Desc: Payment Provider
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {pixModalOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.pixModalOpened = function (params) {
        return this.bi.log(__assign({ evid: 287 }, params));
    };
    /**
    * @typedef {Object} merchantAcceptPaymentsClickedAtBreadcrumbTrailParams
    * @property {GUID} msid - msid
    * @property {string} pageType - what page in the dashboard / origin page
    * @property {string} paymentCategory - creditCard,paypal
    * @property {string} paymentProvider - stripe,paypal,eWay
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {string} targetPage - page where you're going to be redirected
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Accept Payments clicked at breadcrumb trail. Evid: 215.
     * Event description: Merchant-click  Accept Payments at breadcrumb trail. Please see 85:149 for WP events.
    
     * msid - Type: guid. Desc: msid
     *
     * pageType - Type: string. Desc: what page in the dashboard / origin page
     *
     * paymentCategory - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string. Desc: stripe,paypal,eWay
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * targetPage - Type: string. Desc: page where you're going to be redirected
     *
     * visitorId - Type: guid.
     * @param {merchantAcceptPaymentsClickedAtBreadcrumbTrailParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantAcceptPaymentsClickedAtBreadcrumbTrail = function (params) {
        return this.bi.log(__assign({ evid: 215 }, params));
    };
    /**
    * @typedef {Object} merchantShowOnCheckOutClickedParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - creditCard,paypal
    * @property {string} paymentProvider - stripe,paypal,eWay
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {boolean} showBuyer - true/false
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Show on Checkout clicked. Evid: 129.
     * Event description: Merchant-click hide payment provider.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string. Desc: stripe,paypal,eWay
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * showBuyer - Type: bool. Desc: true/false
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantShowOnCheckOutClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantShowOnCheckOutClicked = function (params) {
        return this.bi.log(__assign({ evid: 129 }, params));
    };
    /**
    * @typedef {Object} openPopUpParams
    * @property {string} flowType - e.g. cbd flow
    * @property {GUID} msid - null
    * @property {string} page - e.g. Attestation form / Accepting Payments / etc.
    * @property {string} popupName - popup name
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Open PopUp. Evid: 219.
     * Event description: popup was opened on the page.
    
     * flowType - Type: string. Desc: e.g. cbd flow
     *
     * msid - Type: guid.
     *
     * page - Type: string. Desc: e.g. Attestation form / Accepting Payments / etc.
     *
     * popupName - Type: string. Desc: popup name
     *
     * visitorId - Type: guid.
     * @param {openPopUpParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.openPopUp = function (params) {
        return this.bi.log(__assign({ evid: 219 }, params));
    };
    /**
    * @typedef {Object} myWalletPageStartedLoadingParams
    * @property {number} hasSavedCreditCards - number of saved credit cards
    * @property {GUID} member_id -
    * @property {GUID} memberId - member_id
    * @property {GUID} msid - msid
    * @property {string} origin - profile / side menu
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: My Wallet - page started loading. Evid: 220.
     * Event description: Logged in member enters My Wallet page.
    
     * hasSavedCreditCards - Type: numeric. Desc: number of saved credit cards
     *
     * member_id - Type: guid.
     *
     * memberId - Type: guid. Desc: member_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: profile / side menu
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {myWalletPageStartedLoadingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.myWalletPageStartedLoading = function (params) {
        return this.bi.log(__assign({ evid: 220 }, params));
    };
    /**
    * @typedef {Object} merchantPremiumBannerShownParams
    * @property {string} bannerName - You're one step closer to selling online, Upgrade with a Business & eCommerce Premium Plan so customers can pay you at checkout
    * @property {GUID} msid - null
    * @property {string} pageType - page where banner was shown - accept_payment/manage_page etc
    * @property {string} paymentCategory - creditCard,paypal
    * @property {string} paymentProvider - stripe,paypal,eWay
    * @property {string} place - place where banner is located - accept_payment_top_page,connect_payment_method_modal
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant Premium Banner shown. Evid: 253.
     * Event description: Upgrade banner was shown to the user at Accept payment page.
    
     * bannerName - Type: string. Desc: You're one step closer to selling online, Upgrade with a Business & eCommerce Premium Plan so customers can pay you at checkout
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: page where banner was shown - accept_payment/manage_page etc
     *
     * paymentCategory - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string. Desc: stripe,paypal,eWay
     *
     * place - Type: string. Desc: place where banner is located - accept_payment_top_page,connect_payment_method_modal
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantPremiumBannerShownParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantPremiumBannerShown = function (params) {
        return this.bi.log(__assign({ evid: 253 }, params));
    };
    /**
    * @typedef {Object} boSitePageRefundResultsParams
    * @property {number} amount - amount
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {boolean} status - request status
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page refund results. Evid: 414.
     * Event description: Refund sent and we show result pop-up.
    
     * amount - Type: numeric. Desc: amount
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * status - Type: bool. Desc: request status
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boSitePageRefundResultsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageRefundResults = function (params) {
        return this.bi.log(__assign({ evid: 414 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnGoToDashboardParams
    * @property {GUID} msid - null
    * @property {string} pageType - manage_page
    * @property {string} paymentCategory - creditCard,cardReader etc
    * @property {string} paymentProvider - wixpay_adyen, wixpay_stripe
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Click on Go to Dashboard. Evid: 270.
     * Event description: Merchant Click on Go to Dashboard at Wix Payments Manage Page.
    
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: manage_page
     *
     * paymentCategory - Type: string. Desc: creditCard,cardReader etc
     *
     * paymentProvider - Type: string. Desc: wixpay_adyen, wixpay_stripe
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantClickOnGoToDashboardParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnGoToDashboard = function (params) {
        return this.bi.log(__assign({ evid: 270 }, params));
    };
    /**
    * @typedef {Object} merchantClickViewPayoutsParams
    * @property {GUID} msid - null
    * @property {string} pageType - page where user at
    * @property {string} paymentCategory - payment method
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Click View Payouts. Evid: 280.
     * Event description: Click on View Payouts at Accept Payments.
    
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: page where user at
     *
     * paymentCategory - Type: string. Desc: payment method
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantClickViewPayoutsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickViewPayouts = function (params) {
        return this.bi.log(__assign({ evid: 280 }, params));
    };
    /**
    * @typedef {Object} spbButtonSuccessInitializationCheckoutParams
    * @property {string} cartId - cart id
    * @property {string} ecToken - PayPal token id
    * @property {GUID} msid - msid
    * @property {string} paymentProvider - payment_provider that chosen (PayPal, Wixpayments etc.)
    * @property {string} paymentmethod - payment method in provider (Venmo, PayPal Credit etc.)
    * @property {string} sessionId - unique payment session to connect orders and trxs
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: SPB button successInitializationCheckout. Evid: 214.
     * Event description: Smart Payment Button success Initialization Checkout (order created on PayPal - user is able to login/select payment method).
    
     * cartId - Type: string. Desc: cart id
     *
     * ecToken - Type: string. Desc: PayPal token id
     *
     * msid - Type: guid. Desc: msid
     *
     * paymentProvider - Type: string. Desc: payment_provider that chosen (PayPal, Wixpayments etc.)
     *
     * paymentmethod - Type: string. Desc: payment method in provider (Venmo, PayPal Credit etc.)
     *
     * sessionId - Type: string. Desc: unique payment session to connect orders and trxs
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {spbButtonSuccessInitializationCheckoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.spbButtonSuccessInitializationCheckout = function (params) {
        return this.bi.log(__assign({ evid: 214 }, params));
    };
    /**
    * @typedef {Object} merchantVerifyAccountClicked284Params
    * @property {GUID} msid - null
    * @property {string} pageType - page where user at
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Verify Account clicked. Evid: 284.
     * Event description: Click on Verify Account on Accept Payment.
    
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: page where user at
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantVerifyAccountClicked284Params} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantVerifyAccountClicked284 = function (params) {
        return this.bi.log(__assign({ evid: 284 }, params));
    };
    /**
    * @typedef {Object} merchantClickedLinkOnConnectPageParams
    * @property {GUID} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} link_name - alias for link on a page
    * @property {string} linkUrl - url where user will be redirected
    * @property {GUID} msid - null
    * @property {string} paymentCategory - creditCard,paypal
    * @property {string} paymentProvider - stripe,paypal,eWay
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant -  clicked link on connect page. Evid: 255.
     * Event description: Merchant clicked link on connect page.
    
     * appId - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * link_name - Type: string. Desc: alias for link on a page
     *
     * linkUrl - Type: string. Desc: url where user will be redirected
     *
     * msid - Type: guid.
     *
     * paymentCategory - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string. Desc: stripe,paypal,eWay
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantClickedLinkOnConnectPageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickedLinkOnConnectPage = function (params) {
        return this.bi.log(__assign({ evid: 255 }, params));
    };
    /**
    * @typedef {Object} merchantConfirmDisconnectPopupParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} interaction - popup shown / disconnect confirmed
    * @property {GUID} msid - msid
    * @property {string} origin - disconnect / connect other
    * @property {string} paymentCategory - currently connected category
    * @property {string} paymentProvider - currently connected provider
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Confirm Disconnect popup. Evid: 183.
     * Event description: when users wants do disconnect WixPay (directly or because of connecting other provider), we show notification popup.
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * interaction - Type: string. Desc: popup shown / disconnect confirmed
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: disconnect / connect other
     *
     * paymentCategory - Type: string. Desc: currently connected category
     *
     * paymentProvider - Type: string. Desc: currently connected provider
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {merchantConfirmDisconnectPopupParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantConfirmDisconnectPopup = function (params) {
        return this.bi.log(__assign({ evid: 183 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnCreateAnAccountOnThePaymentMethodModalFirstPageParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - Credit Card
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - click on create an account on the payment method modal-first page. Evid: 149.
     * Event description: Merchant - click on create an account on the payment method modal-first page.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: Credit Card
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantClickOnCreateAnAccountOnThePaymentMethodModalFirstPageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnCreateAnAccountOnThePaymentMethodModalFirstPage = function (params) {
        return this.bi.log(__assign({ evid: 149 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickSwitchAccountToggleParams
    * @property {GUID} accountId - new account_id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click switch account toggle. Evid: 433.
     * Event description: Employee  click switch account toggle.
    
     * accountId - Type: guid. Desc: new account_id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickSwitchAccountToggleParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickSwitchAccountToggle = function (params) {
        return this.bi.log(__assign({ evid: 433 }, params));
    };
    /**
    * @typedef {Object} merchantChooseBusinessLocationParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} businessLocation - the country that the user selected
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} origin - seamless/classic
    * @property {string} platformName - desktop/oneApp etc
    * @property {string} type - first_entry/country_list
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Business Location selected. Evid: 133.
     * Event description: Merchant -choose business location.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * businessLocation - Type: string. Desc: the country that the user selected
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * origin - Type: string. Desc: seamless/classic
     *
     * platformName - Type: string. Desc: desktop/oneApp etc
     *
     * type - Type: string. Desc: first_entry/country_list
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantChooseBusinessLocationParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantChooseBusinessLocation = function (params) {
        return this.bi.log(__assign({ evid: 133 }, params));
    };
    /**
    * @typedef {Object} wixCodeCheckOutErrorOccurredParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id (cashier)
    * @property {GUID} cashierInstanceId - cashier_instance_id
    * @property {string} direction - NOT IN USE: button name (incl. close)
    * @property {number} duration - NOT IN USE: loading time in miliseconds
    * @property {string} errorDesc - error details
    * @property {string} errorType - generic, input
    * @property {string} merchantDefinedFields - buyer details, specified by merchant
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} page - name of the page
    * @property {string} pageFrom - NOT IN USE: page buyer is redirected from
    * @property {string} pageTo - NOT IN USE: page buyer will be navigated to
    * @property {string} paymentMethodsAvailable - list of available payment methods
    * @property {string} paymentMethodSelected - payment method selected if known
    * @property {string} selectedCountry - country chosen by buyer
    * @property {boolean} showThankYouPage - merchant enables thank you page
    * @property {string} status - NOT IN USE: transaction status for thank you page
    * @property {boolean} termsAndConditions - true if shown, false is not shown
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Wix Code Checkout - Error occurred. Evid: 205.
     * Event description: Wix Code Check out - Error occurred.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id (cashier)
     *
     * cashierInstanceId - Type: guid. Desc: cashier_instance_id
     *
     * direction - Type: string. Desc: NOT IN USE: button name (incl. close)
     *
     * duration - Type: numeric. Desc: NOT IN USE: loading time in miliseconds
     *
     * errorDesc - Type: string. Desc: error details
     *
     * errorType - Type: string. Desc: generic, input
     *
     * merchantDefinedFields - Type: string. Desc: buyer details, specified by merchant
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * page - Type: string. Desc: name of the page
     *
     * pageFrom - Type: string. Desc: NOT IN USE: page buyer is redirected from
     *
     * pageTo - Type: string. Desc: NOT IN USE: page buyer will be navigated to
     *
     * paymentMethodsAvailable - Type: string. Desc: list of available payment methods
     *
     * paymentMethodSelected - Type: string. Desc: payment method selected if known
     *
     * selectedCountry - Type: string. Desc: country chosen by buyer
     *
     * showThankYouPage - Type: bool. Desc: merchant enables thank you page
     *
     * status - Type: string. Desc: NOT IN USE: transaction status for thank you page
     *
     * termsAndConditions - Type: bool. Desc: true if shown, false is not shown
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {wixCodeCheckOutErrorOccurredParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wixCodeCheckOutErrorOccurred = function (params) {
        return this.bi.log(__assign({ evid: 205 }, params));
    };
    /**
    * @typedef {Object} merchantClicksConfirmAtProhibitedProductsPageListParams
    * @property {string} businessLocation - 2-letter country code of location selected by a user
    * @property {GUID} msid - null
    * @property {string} pageType - prohibited_products_list
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {string} selected_value - values, that user have selected semicolon separated
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - clicks Confirm at Prohibited products page list. Evid: 241.
     * Event description: Merchant clicks Confirm at Prohibited products page list.
    
     * businessLocation - Type: string. Desc: 2-letter country code of location selected by a user
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: prohibited_products_list
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * selected_value - Type: string. Desc: values, that user have selected semicolon separated
     *
     * visitorId - Type: guid.
     * @param {merchantClicksConfirmAtProhibitedProductsPageListParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClicksConfirmAtProhibitedProductsPageList = function (params) {
        return this.bi.log(__assign({ evid: 241 }, params));
    };
    /**
    * @typedef {Object} paymentDashboardCurrencyChangedParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} changeFromCurrency - change_from_currency
    * @property {string} changeToCurrency - change_to_currency
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Payment Dashboard - currency changed. Evid: 170.
     * Event description: Currency.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * changeFromCurrency - Type: string. Desc: change_from_currency
     *
     * changeToCurrency - Type: string. Desc: change_to_currency
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {paymentDashboardCurrencyChangedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paymentDashboardCurrencyChanged = function (params) {
        return this.bi.log(__assign({ evid: 170 }, params));
    };
    /**
    * @typedef {Object} clickDoneOnCompleteSummaryWithoutPremiumParams
    * @property {GUID} appid - appid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitor_id - visitor_id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Click Done on Complete Summary without Premium. Evid: 187.
     * Event description: The User who already has a premium bought, should see the pop-up with an additional button "Done" and click it.
    
     * appid - Type: guid. Desc: appid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitor_id - Type: guid. Desc: visitor_id
     *
     * visitorId - Type: guid.
     * @param {clickDoneOnCompleteSummaryWithoutPremiumParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.clickDoneOnCompleteSummaryWithoutPremium = function (params) {
        return this.bi.log(__assign({ evid: 187 }, params));
    };
    /**
    * @typedef {Object} popUpConfigureOtherVerticalsSettingsParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {boolean} doNotShowAgain - true if user clicks on "got it" having checked "Don't show again"
    * @property {string} interaction - shown / closed / [vertical] go to link
    * @property {GUID} msid - msid
    * @property {GUID} userGuid - uuid
    * @property {string} verticalsLinkShown - list of verticals, not integrated with Cashier and with out payment settings
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Unsupported Verticals popup shown. Evid: 172.
     * Event description: When user enters Accept Payments Tab in BM, having installed verticals with payment settings, which are not integrated with Cashier, User is shown to Pop-up with links to these verticals. The event shows also User interaction with the pop-up.
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * doNotShowAgain - Type: bool. Desc: true if user clicks on "got it" having checked "Don't show again"
     *
     * interaction - Type: string. Desc: shown / closed / [vertical] go to link
     *
     * msid - Type: guid. Desc: msid
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * verticalsLinkShown - Type: string. Desc: list of verticals, not integrated with Cashier and with out payment settings
     *
     * visitorId - Type: guid.
     * @param {popUpConfigureOtherVerticalsSettingsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.popUpConfigureOtherVerticalsSettings = function (params) {
        return this.bi.log(__assign({ evid: 172 }, params));
    };
    /**
    * @typedef {Object} merchantChangesSavedSuccessfullyAtManagePageParams
    * @property {string} fields - softDescriptor
    * @property {GUID} msid - null
    * @property {string} pageType - manage_page
    * @property {string} paymentCategory - CreditCard,cardReader etc
    * @property {string} paymentProvider - payment_provider
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {string} type - setting types for WixPayments onboarding: Statement| Payout
    * @property {GUID} visitorId - null
    * @property {string} wpGeo - wp geo
    **/
    /**
     * Name: Merchant > Changes Saved Successfully at Manage Page. Evid: 273.
     * Event description: Merchant Successfully Changed settings at Manage Page.
    
     * fields - Type: string. Desc: softDescriptor
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: manage_page
     *
     * paymentCategory - Type: string. Desc: CreditCard,cardReader etc
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * type - Type: string. Desc: setting types for WixPayments onboarding: Statement| Payout
     *
     * visitorId - Type: guid.
     *
     * wpGeo - Type: string. Desc: wp geo
     * @param {merchantChangesSavedSuccessfullyAtManagePageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantChangesSavedSuccessfullyAtManagePage = function (params) {
        return this.bi.log(__assign({ evid: 273 }, params));
    };
    /**
    * @typedef {Object} boSitePageLoadParams
    * @property {string} displayName - employee displayName
    * @property {number} loadTime - loadtime
    * @property {GUID} msid - msid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page load. Evid: 403.
     * Event description: Employee open Site page.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * loadTime - Type: numeric. Desc: loadtime
     *
     * msid - Type: guid. Desc: msid
     *
     * visitorId - Type: guid.
     * @param {boSitePageLoadParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageLoad = function (params) {
        return this.bi.log(__assign({ evid: 403 }, params));
    };
    /**
    * @typedef {Object} merchantOpenToolTipParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} pageName - connected in payment methods
    * @property {string} paymentCategory - paymentCategory
    * @property {string} paymentProvider - payment_provider
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant-open tool tip. Evid: 142.
     * Event description: Merchant--click on canel in the update modal- General event for click on cancel or exsit in the modal.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * pageName - Type: string. Desc: connected in payment methods
     *
     * paymentCategory - Type: string. Desc: paymentCategory
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantOpenToolTipParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantOpenToolTip = function (params) {
        return this.bi.log(__assign({ evid: 142 }, params));
    };
    /**
    * @typedef {Object} expressCheckoutMorePaymentOptionsButtonClickedParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} origin - page type where widget was loaded
    * @property {string} productId - product id
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Express checkout more payment options button clicked. Evid: 282.
     * Event description: When user click on button.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: page type where widget was loaded
     *
     * productId - Type: string. Desc: product id
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {expressCheckoutMorePaymentOptionsButtonClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.expressCheckoutMorePaymentOptionsButtonClicked = function (params) {
        return this.bi.log(__assign({ evid: 282 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnPremiumBannerParams
    * @property {string} bannerName - You're one step closer to selling online,Upgrade with a Business & eCommerce Premium Plan so customers can pay you at checkout
    * @property {string} cta - upgrade, close
    * @property {GUID} msid - null
    * @property {string} pageType - page where banner was shown - accept_payment/manage_page etc
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant click on Premium Banner. Evid: 254.
     * Event description: User clicks on Upgrade Banner at Accept Payment Page.
    
     * bannerName - Type: string. Desc: You're one step closer to selling online,Upgrade with a Business & eCommerce Premium Plan so customers can pay you at checkout
     *
     * cta - Type: string. Desc: upgrade, close
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: page where banner was shown - accept_payment/manage_page etc
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantClickOnPremiumBannerParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnPremiumBanner = function (params) {
        return this.bi.log(__assign({ evid: 254 }, params));
    };
    /**
    * @typedef {Object} paymentDashboardNavigateToOrderClickedParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} transactionId - transaction_id
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Payment Dashboard - navigate to order clicked. Evid: 162.
     * Event description: user clicks on Go to Order.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * transactionId - Type: guid. Desc: transaction_id
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {paymentDashboardNavigateToOrderClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paymentDashboardNavigateToOrderClicked = function (params) {
        return this.bi.log(__assign({ evid: 162 }, params));
    };
    /**
    * @typedef {Object} merchantMorePaymentOptionsPageShowedParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - null
    * @property {string} page - null
    * @property {string} paymentMethod - creditCard,paypal
    * @property {string} paymentProvider - null
    * @property {string} platformName - desktop/oneApp etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Accept Payments page was shown. Evid: 250.
     * Event description: Event includes all pages in Accept Payments component.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid.
     *
     * page - Type: string.
     *
     * paymentMethod - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string.
     *
     * platformName - Type: string. Desc: desktop/oneApp etc
     *
     * visitorId - Type: guid.
     * @param {merchantMorePaymentOptionsPageShowedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantMorePaymentOptionsPageShowed = function (params) {
        return this.bi.log(__assign({ evid: 250 }, params));
    };
    /**
    * @typedef {Object} revalidateSessionByWidgetParams
    * @property {GUID} msid - null
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Revalidate session by Widget. Evid: 281.
     * Event description: BI event for "revalidate session" call by the Widget to help with investigating a mysterious issue with "changing visitorId".
    
     * msid - Type: guid.
     *
     * visitorId - Type: guid.
     * @param {revalidateSessionByWidgetParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.revalidateSessionByWidget = function (params) {
        return this.bi.log(__assign({ evid: 281 }, params));
    };
    /**
    * @typedef {Object} merchantWixPaymentsLearnMoreClickedParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} origin - Welcome page / Add provider
    * @property {string} paymentProvider - payment provider
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Wix Payments Learn More clicked. Evid: 171.
     * Event description: User clicks on Learn More for Wix Payments.
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Welcome page / Add provider
     *
     * paymentProvider - Type: string. Desc: payment provider
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid.
     * @param {merchantWixPaymentsLearnMoreClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantWixPaymentsLearnMoreClicked = function (params) {
        return this.bi.log(__assign({ evid: 171 }, params));
    };
    /**
    * @typedef {Object} wixCodeCheckOutPageStartedLoadingParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id (cashier)
    * @property {GUID} cashierInstanceId - cashier_instance_id
    * @property {string} direction - NOT IN USE: button name
    * @property {number} duration - loading time in miliseconds from buyer activity to page started loading
    * @property {string} errorDesc - NOT IN USE: error details
    * @property {string} errorType - NOT IN USE: generic, input
    * @property {string} merchantDefinedFields - buyer details, specified by merchant
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} page - name of the page
    * @property {string} pageFrom - page buyer is redirected from
    * @property {string} pageTo - NOT IN USE: page buyer will be navigated to
    * @property {string} paymentMethodsAvailable - list of available payment methods
    * @property {string} paymentMethodSelected - payment method selected if known
    * @property {string} selectedCountry - country chosen by buyer
    * @property {boolean} showThankYouPage - merchant enables thank you page
    * @property {string} status - transaction status for thank you page
    * @property {boolean} termsAndConditions - true if shown, false is not shown
    * @property {boolean} thunderbolt - if loading was from thunderbolt then TRUE
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Wix Code Checkout - Page started loading. Evid: 200.
     * Event description: Wix Code Check out - Page started loading.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id (cashier)
     *
     * cashierInstanceId - Type: guid. Desc: cashier_instance_id
     *
     * direction - Type: string. Desc: NOT IN USE: button name
     *
     * duration - Type: numeric. Desc: loading time in miliseconds from buyer activity to page started loading
     *
     * errorDesc - Type: string. Desc: NOT IN USE: error details
     *
     * errorType - Type: string. Desc: NOT IN USE: generic, input
     *
     * merchantDefinedFields - Type: string. Desc: buyer details, specified by merchant
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * page - Type: string. Desc: name of the page
     *
     * pageFrom - Type: string. Desc: page buyer is redirected from
     *
     * pageTo - Type: string. Desc: NOT IN USE: page buyer will be navigated to
     *
     * paymentMethodsAvailable - Type: string. Desc: list of available payment methods
     *
     * paymentMethodSelected - Type: string. Desc: payment method selected if known
     *
     * selectedCountry - Type: string. Desc: country chosen by buyer
     *
     * showThankYouPage - Type: bool. Desc: merchant enables thank you page
     *
     * status - Type: string. Desc: transaction status for thank you page
     *
     * termsAndConditions - Type: bool. Desc: true if shown, false is not shown
     *
     * thunderbolt - Type: bool. Desc: if loading was from thunderbolt then TRUE
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {wixCodeCheckOutPageStartedLoadingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wixCodeCheckOutPageStartedLoading = function (params) {
        return this.bi.log(__assign({ evid: 200 }, params));
    };
    /**
    * @typedef {Object} wixCodeCheckOutBuyerChoosesCountryParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id (cashier)
    * @property {GUID} cashierInstanceId - cashier_instance_id
    * @property {string} direction - NOT IN USE: button name (incl. close)
    * @property {number} duration - NOT IN USE: loading time in miliseconds
    * @property {string} errorDesc - NOT IN USE: error details
    * @property {string} errorType - NOT IN USE: generic, input
    * @property {string} merchantDefinedFields - buyer details, specified by merchant
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} page - name of the page
    * @property {string} pageFrom - NOT IN USE: page buyer is redirected from
    * @property {string} pageTo - NOT IN USE: page buyer will be navigated to
    * @property {string} paymentMethodsAvailable - list of available payment methods
    * @property {string} paymentMethodSelected - payment method selected if known
    * @property {string} selectedCountry - country chosen by buyer
    * @property {boolean} showThankYouPage - merchant enables thank you page
    * @property {string} status - NOT IN USE: transaction status for thank you page
    * @property {boolean} termsAndConditions - true if shown, false is not shown
    * @property {boolean} thunderbolt - if loading was from thunderbolt then TRUE
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Wix Code Checkout - Buyer chooses country. Evid: 203.
     * Event description: Wix Code Check out - Buyer chooses country.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id (cashier)
     *
     * cashierInstanceId - Type: guid. Desc: cashier_instance_id
     *
     * direction - Type: string. Desc: NOT IN USE: button name (incl. close)
     *
     * duration - Type: numeric. Desc: NOT IN USE: loading time in miliseconds
     *
     * errorDesc - Type: string. Desc: NOT IN USE: error details
     *
     * errorType - Type: string. Desc: NOT IN USE: generic, input
     *
     * merchantDefinedFields - Type: string. Desc: buyer details, specified by merchant
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * page - Type: string. Desc: name of the page
     *
     * pageFrom - Type: string. Desc: NOT IN USE: page buyer is redirected from
     *
     * pageTo - Type: string. Desc: NOT IN USE: page buyer will be navigated to
     *
     * paymentMethodsAvailable - Type: string. Desc: list of available payment methods
     *
     * paymentMethodSelected - Type: string. Desc: payment method selected if known
     *
     * selectedCountry - Type: string. Desc: country chosen by buyer
     *
     * showThankYouPage - Type: bool. Desc: merchant enables thank you page
     *
     * status - Type: string. Desc: NOT IN USE: transaction status for thank you page
     *
     * termsAndConditions - Type: bool. Desc: true if shown, false is not shown
     *
     * thunderbolt - Type: bool. Desc: if loading was from thunderbolt then TRUE
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {wixCodeCheckOutBuyerChoosesCountryParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.wixCodeCheckOutBuyerChoosesCountry = function (params) {
        return this.bi.log(__assign({ evid: 203 }, params));
    };
    /**
    * @typedef {Object} boAccountPageLoadParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {number} loadTime - loadtime
    * @property {GUID} msid - msid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page load. Evid: 415.
     * Event description: Employee open Account page.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * loadTime - Type: numeric. Desc: loadtime
     *
     * msid - Type: guid. Desc: msid
     *
     * visitorId - Type: guid.
     * @param {boAccountPageLoadParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageLoad = function (params) {
        return this.bi.log(__assign({ evid: 415 }, params));
    };
    /**
    * @typedef {Object} myWalletPageFinishedLoadingParams
    * @property {number} duration - milliseconds from load started to load finished
    * @property {number} hasSavedCreditCards - number of saved credit cards
    * @property {GUID} member_id - -
    * @property {GUID} memberId - member_id
    * @property {GUID} msid - msid
    * @property {string} origin - profile / side menu
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: My Wallet - page finished loading. Evid: 221.
     * Event description: Logged in member enters My Wallet page.
    
     * duration - Type: numeric. Desc: milliseconds from load started to load finished
     *
     * hasSavedCreditCards - Type: numeric. Desc: number of saved credit cards
     *
     * member_id - Type: guid. Desc: -
     *
     * memberId - Type: guid. Desc: member_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: profile / side menu
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {myWalletPageFinishedLoadingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.myWalletPageFinishedLoading = function (params) {
        return this.bi.log(__assign({ evid: 221 }, params));
    };
    /**
    * @typedef {Object} checkOutMandatoryFieldsShownParams
    * @property {GUID} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} creditCardId - credit_card_id
    * @property {string} mandatoryFieldsList - list of mandatory fields to be fulfilled by buyer
    * @property {GUID} memberId - member_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderId - vertical order id
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} pageType - page_type
    * @property {string} paymentCategory - payment_category
    * @property {string} paymentProvider - payment_provider
    * @property {string} paymentMethod - Offline payment, MercadoPago, Paypal, Credit card
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout - Fields to be fulfilled by buyer. Evid: 164.
     * Event description: list of mandatory & CC fields to be fulfilled by buyer.
    
     * appId - Type: guid. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * creditCardId - Type: guid. Desc: credit_card_id
     *
     * mandatoryFieldsList - Type: string. Desc: list of mandatory fields to be fulfilled by buyer
     *
     * memberId - Type: guid. Desc: member_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderId - Type: string. Desc: vertical order id
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * pageType - Type: string. Desc: page_type
     *
     * paymentCategory - Type: string. Desc: payment_category
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * paymentMethod - Type: string. Desc: Offline payment, MercadoPago, Paypal, Credit card
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {checkOutMandatoryFieldsShownParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkOutMandatoryFieldsShown = function (params) {
        return this.bi.log(__assign({ evid: 164 }, params));
    };
    /**
    * @typedef {Object} merchantAcceptPaymentsPageLoadCompleteParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {number} duration - loading time in miliseconds
    * @property {string} flowType - specific flows. e.g. CBD flow
    * @property {string} merchantResolvedCountry - the country we get from the server
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} offeredPaymentCategory - array of offered payment_methods
    * @property {string} origin - place user came from
    * @property {string} page - Payments Overview / smart onBoarding welcome / smart onBoarding connect
    * @property {string} paymentCategory - array of connected payment_methods
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {boolean} status - 1-success/ 0-failed
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Accept Payments Page Load Complete. Evid: 108.
     * Event description: Merchant click on payment settings in TPA and the cashier payment method page load successfully. In case of wix.numeric--parsing error--duration, please reopen https://jira.wixpress.com/browse/PAY-6934.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * duration - Type: numeric. Desc: loading time in miliseconds
     *
     * flowType - Type: string. Desc: specific flows. e.g. CBD flow
     *
     * merchantResolvedCountry - Type: string. Desc: the country we get from the server
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * offeredPaymentCategory - Type: string. Desc: array of offered payment_methods
     *
     * origin - Type: string. Desc: place user came from
     *
     * page - Type: string. Desc: Payments Overview / smart onBoarding welcome / smart onBoarding connect
     *
     * paymentCategory - Type: string. Desc: array of connected payment_methods
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * status - Type: bool. Desc: 1-success/ 0-failed
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantAcceptPaymentsPageLoadCompleteParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantAcceptPaymentsPageLoadComplete = function (params) {
        return this.bi.log(__assign({ evid: 108 }, params));
    };
    /**
    * @typedef {Object} merchantGenericErrorsParams
    * @property {string} errorDesc - error description
    * @property {string} message - message (full text message)
    * @property {GUID} msid - null
    * @property {string} pageType - page where error was appeared
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - generic errors. Evid: 285.
     * Event description: Generic error in BM at payment funnel.
    
     * errorDesc - Type: string. Desc: error description
     *
     * message - Type: string. Desc: message (full text message)
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: page where error was appeared
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantGenericErrorsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantGenericErrors = function (params) {
        return this.bi.log(__assign({ evid: 285 }, params));
    };
    /**
    * @typedef {Object} paymentDashboardSortingAppliedParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} sortBy - currently date only
    * @property {string} sortOrder - asc / desc
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Payment Dashboard - sorting applied. Evid: 158.
     * Event description: Sorting by date is applied.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * sortBy - Type: string. Desc: currently date only
     *
     * sortOrder - Type: string. Desc: asc / desc
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {paymentDashboardSortingAppliedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paymentDashboardSortingApplied = function (params) {
        return this.bi.log(__assign({ evid: 158 }, params));
    };
    /**
    * @typedef {Object} checkOutViewTooltipParams
    * @property {string} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} buyerComponent - defines new buyer component (null for old, 'react' for new one)
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} pageType - paymentType
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout - View tooltip. Evid: 101.
     * Event description: The visitoer looked at the tooltip.
    
     * appId - Type: string. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * buyerComponent - Type: string. Desc: defines new buyer component (null for old, 'react' for new one)
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * pageType - Type: string. Desc: paymentType
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {checkOutViewTooltipParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkOutViewTooltip = function (params) {
        return this.bi.log(__assign({ evid: 101 }, params));
    };
    /**
    * @typedef {Object} merchantClickOnConnectOnThePaymentMethodModalFirstPageParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - Credit Card
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - click on connect on the payment method modal-first page. Evid: 148.
     * Event description: Merchant - click on connect on the payment method modal-first page.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: Credit Card
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantClickOnConnectOnThePaymentMethodModalFirstPageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOnConnectOnThePaymentMethodModalFirstPage = function (params) {
        return this.bi.log(__assign({ evid: 148 }, params));
    };
    /**
    * @typedef {Object} merchantPosLearnMoreClickedParams
    * @property {GUID} appid - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} origin - Welcome page / Add provider
    * @property {GUID} userGuid - uuid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - POS Learn More clicked. Evid: 188.
     * Event description: User clicks on Learn More for POS (must be linked to KB).
    
     * appid - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: Welcome page / Add provider
     *
     * userGuid - Type: guid. Desc: uuid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantPosLearnMoreClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantPosLearnMoreClicked = function (params) {
        return this.bi.log(__assign({ evid: 188 }, params));
    };
    /**
    * @typedef {Object} checkOutNoAvailableProvidersPopUpShownParams
    * @property {string} appId - vetrical
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} buyerComponent - buyer_component
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderId - order id
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} paymentCategory - Offline payment, MercadoPago, Paypal, Credit card
    * @property {string} paymentProvider - payment_provider
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout - No available providers Pop up shown. Evid: 174.
     * Event description: When buyer comes to Payment Component on a check-out, and all of connected providers are disabled, we show notification to a buyer.
    
     * appId - Type: string. Desc: vetrical
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * buyerComponent - Type: string. Desc: buyer_component
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderId - Type: string. Desc: order id
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * paymentCategory - Type: string. Desc: Offline payment, MercadoPago, Paypal, Credit card
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {checkOutNoAvailableProvidersPopUpShownParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkOutNoAvailableProvidersPopUpShown = function (params) {
        return this.bi.log(__assign({ evid: 174 }, params));
    };
    /**
    * @typedef {Object} merchantLearnMoreFromCompleteSetUpBannerClickedParams
    * @property {GUID} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} paymentCategory - creditCard,paypal
    * @property {string} paymentProvider - stripe,paypal,eWay
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant Learn More from Complete Set-Up Banner Clicked. Evid: 167.
     * Event description: User clicks on Learn More in Complete Set-Up Banner (for providers with deferred account.
    
     * appId - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * paymentCategory - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string. Desc: stripe,paypal,eWay
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantLearnMoreFromCompleteSetUpBannerClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantLearnMoreFromCompleteSetUpBannerClicked = function (params) {
        return this.bi.log(__assign({ evid: 167 }, params));
    };
    /**
    * @typedef {Object} merchantClickSaveAtManagePageParams
    * @property {string} fields - softDescriptor
    * @property {GUID} msid - null
    * @property {string} pageType - manage_page
    * @property {string} paymentCategory - CreditCard,cardReader etc
    * @property {string} paymentProvider - payment_provider
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {string} type - setting types for WixPayments onboarding: Statement| Payout
    * @property {GUID} visitorId - null
    * @property {string} wpGeo - wp geo
    **/
    /**
     * Name: Merchant > Click Save at Manage Page. Evid: 272.
     * Event description: Merchant > Click Save at manage page.
    
     * fields - Type: string. Desc: softDescriptor
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: manage_page
     *
     * paymentCategory - Type: string. Desc: CreditCard,cardReader etc
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * type - Type: string. Desc: setting types for WixPayments onboarding: Statement| Payout
     *
     * visitorId - Type: guid.
     *
     * wpGeo - Type: string. Desc: wp geo
     * @param {merchantClickSaveAtManagePageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickSaveAtManagePage = function (params) {
        return this.bi.log(__assign({ evid: 272 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickAdyenUrlParams
    * @property {GUID} accountId - null
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant
    * @property {Url} url - Adyen BO url
    * @property {GUID} visitorId - visitor id
    **/
    /**
     * Name: [BO] Account Page click adyen url. Evid: 439.
     * Event description: Employee  click adyen url.
    
     * accountId - Type: guid.
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant
     *
     * url - Type: url. Desc: Adyen BO url
     *
     * visitorId - Type: guid. Desc: visitor id
     * @param {boAccountPageClickAdyenUrlParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickAdyenUrl = function (params) {
        return this.bi.log(__assign({ evid: 439 }, params));
    };
    /**
    * @typedef {Object} expressCheckoutWidgetLoadingFinishedParams
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} currency - currency
    * @property {string} flowType - Apple JS version
    * @property {GUID} msid - null
    * @property {string} origin - page type where widget was loaded
    * @property {string} paymentmethod - list of methods that widget contains
    * @property {string} productId - product_id where widget is loaded
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Express checkout widget loading finished. Evid: 262.
     * Event description: When express widget loading finished.
    
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * currency - Type: string. Desc: currency
     *
     * flowType - Type: string. Desc: Apple JS version
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: page type where widget was loaded
     *
     * paymentmethod - Type: string. Desc: list of methods that widget contains
     *
     * productId - Type: string. Desc: product_id where widget is loaded
     *
     * visitorId - Type: guid.
     * @param {expressCheckoutWidgetLoadingFinishedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.expressCheckoutWidgetLoadingFinished = function (params) {
        return this.bi.log(__assign({ evid: 262 }, params));
    };
    /**
    * @typedef {Object} paymentsComponentLoadCompleteParams
    * @property {string} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} buyerComponent - defines new buyer component (null for old, 'react' for new one)
    * @property {number} duration - loading time in miliseconds
    * @property {string} errorDesc - A technical error string. Empty if load complete successfully
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} pageType - payment method menu,payment page
    * @property {string} payWith - pay_with
    * @property {string} paymentCategory - CreditCard/Ewallet,offline
    * @property {string} paymentProvider - com.stripe/net.authorize
    * @property {string} source - 1.pay with, 2.buyer choose, 3.one payment method
    * @property {boolean} status - true - success / false - failed
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout - Payments Component load complete. Evid: 126.
     * Event description: The payment method pay page is loaded successfully,.
    
     * appId - Type: string. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * buyerComponent - Type: string. Desc: defines new buyer component (null for old, 'react' for new one)
     *
     * duration - Type: numeric. Desc: loading time in miliseconds
     *
     * errorDesc - Type: string. Desc: A technical error string. Empty if load complete successfully
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * pageType - Type: string. Desc: payment method menu,payment page
     *
     * payWith - Type: string. Desc: pay_with
     *
     * paymentCategory - Type: string. Desc: CreditCard/Ewallet,offline
     *
     * paymentProvider - Type: string. Desc: com.stripe/net.authorize
     *
     * source - Type: string. Desc: 1.pay with, 2.buyer choose, 3.one payment method
     *
     * status - Type: bool. Desc: true - success / false - failed
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {paymentsComponentLoadCompleteParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.paymentsComponentLoadComplete = function (params) {
        return this.bi.log(__assign({ evid: 126 }, params));
    };
    /**
    * @typedef {Object} showClickContactCustomerCareCtaParams
    * @property {string} accountStatus - wix payments account status
    * @property {string} actionType - show / click
    * @property {string} errorMessage - key for message ( kyc / compliance / other)
    * @property {GUID} msid - null
    * @property {string} onboardingType - old / new onboarding
    * @property {string} pageType - payments_dashboard / payouts / accept_payments
    * @property {string} place - place on the page (company / personal etc.)
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {string} url - link to customer care page
    * @property {GUID} visitorId - null
    * @property {string} wpGeo - GEO
    **/
    /**
     * Name: Show / Click Contact Customer care CTA. Evid: 266.
     * Event description: Show / Click "contact customer care" to a user.
    
     * accountStatus - Type: string. Desc: wix payments account status
     *
     * actionType - Type: string. Desc: show / click
     *
     * errorMessage - Type: string. Desc: key for message ( kyc / compliance / other)
     *
     * msid - Type: guid.
     *
     * onboardingType - Type: string. Desc: old / new onboarding
     *
     * pageType - Type: string. Desc: payments_dashboard / payouts / accept_payments
     *
     * place - Type: string. Desc: place on the page (company / personal etc.)
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * url - Type: string. Desc: link to customer care page
     *
     * visitorId - Type: guid.
     *
     * wpGeo - Type: string. Desc: GEO
     * @param {showClickContactCustomerCareCtaParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.showClickContactCustomerCareCta = function (params) {
        return this.bi.log(__assign({ evid: 266 }, params));
    };
    /**
    * @typedef {Object} merchantAddPaymentMethodInPaymentMethodPageParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant- add payment method in payment method page. Evid: 147.
     * Event description: Merchant- add payment method in payment method page- when click on +add.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantAddPaymentMethodInPaymentMethodPageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantAddPaymentMethodInPaymentMethodPage = function (params) {
        return this.bi.log(__assign({ evid: 147 }, params));
    };
    /**
    * @typedef {Object} merchantPaymentMethodPageLoadStartParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {number} duration - loading time in miliseconds
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} platformName - desktop/oneApp etc
    * @property {string} referralInfo - place from which user came to AP
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Accept Payments Page Load Start. Evid: 107.
     * Event description: Merchant click on payment settings in TPA and the cashier payment method page start to load.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * duration - Type: numeric. Desc: loading time in miliseconds
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * platformName - Type: string. Desc: desktop/oneApp etc
     *
     * referralInfo - Type: string. Desc: place from which user came to AP
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantPaymentMethodPageLoadStartParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantPaymentMethodPageLoadStart = function (params) {
        return this.bi.log(__assign({ evid: 107 }, params));
    };
    /**
    * @typedef {Object} boSitePageTransactionRefundClickCancelParams
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page transaction refund click cancel. Evid: 412.
     * Event description: Employee click cancel on refund dialogue.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boSitePageTransactionRefundClickCancelParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageTransactionRefundClickCancel = function (params) {
        return this.bi.log(__assign({ evid: 412 }, params));
    };
    /**
    * @typedef {Object} ctaClickParams
    * @property {string} cta_value - yes/no/save
    * @property {string} flowType - e.g. cbd flow
    * @property {GUID} msid - null
    * @property {string} page - e.g. Attestation form / Accepting Payments / etc.
    * @property {string} popupName - name of popup where click was made
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: CTA click. Evid: 218.
     * Event description: general event for CTA click.
    
     * cta_value - Type: string. Desc: yes/no/save
     *
     * flowType - Type: string. Desc: e.g. cbd flow
     *
     * msid - Type: guid.
     *
     * page - Type: string. Desc: e.g. Attestation form / Accepting Payments / etc.
     *
     * popupName - Type: string. Desc: name of popup where click was made
     *
     * visitorId - Type: guid.
     * @param {ctaClickParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.ctaClick = function (params) {
        return this.bi.log(__assign({ evid: 218 }, params));
    };
    /**
    * @typedef {Object} merchantManagePageLoadCompleteParams
    * @property {GUID} appId - null
    * @property {GUID} appInstanceId - app_instance_id
    * @property {number} duration - loading time in miliseconds
    * @property {string} merchantResolvedCountry - the country we get from the server
    * @property {GUID} msid - null
    * @property {string} paymentMethod - creditCard,paypal
    * @property {string} paymentProvider - null
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {boolean} status - null
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Manage page Load Complete. Evid: 246.
    
    
     * appId - Type: guid.
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * duration - Type: numeric. Desc: loading time in miliseconds
     *
     * merchantResolvedCountry - Type: string. Desc: the country we get from the server
     *
     * msid - Type: guid.
     *
     * paymentMethod - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string.
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * status - Type: bool.
     *
     * visitorId - Type: guid.
     * @param {merchantManagePageLoadCompleteParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantManagePageLoadComplete = function (params) {
        return this.bi.log(__assign({ evid: 246 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickConfirmManualReviewParams
    * @property {GUID} accountId - provider account id
    * @property {string} category - category
    * @property {number} days - # of days until payout
    * @property {boolean} delayPayouts - true false
    * @property {string} displayName - employee displayName
    * @property {string} finding - finding
    * @property {GUID} msid - msid
    * @property {string} reason - reason
    * @property {boolean} status - Status
    * @property {string} tenantId - tenant
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  Confirm Manual Review. Evid: 430.
     * Event description: Employee click Confirm Manual Review.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * category - Type: string. Desc: category
     *
     * days - Type: numeric. Desc: # of days until payout
     *
     * delayPayouts - Type: bool. Desc: true false
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * finding - Type: string. Desc: finding
     *
     * msid - Type: guid. Desc: msid
     *
     * reason - Type: string. Desc: reason
     *
     * status - Type: bool. Desc: Status
     *
     * tenantId - Type: string. Desc: tenant
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickConfirmManualReviewParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickConfirmManualReview = function (params) {
        return this.bi.log(__assign({ evid: 430 }, params));
    };
    /**
    * @typedef {Object} validationErrorAtManagePageParams
    * @property {string} fields - changed fields (list if more than 1)
    * @property {string} invalidFields - invalid fields in the form (list if more than 1)
    * @property {GUID} msid - null
    * @property {string} pageType - manage_page
    * @property {string} paymentCategory - CreditCard,cardReader etc
    * @property {string} paymentProvider - payment_provider
    * @property {GUID} visitorId - null
    * @property {string} wpGeo - wp geo
    **/
    /**
     * Name: Validation Error at Manage Page. Evid: 274.
     * Event description: Validation Error at Manage Page.
    
     * fields - Type: string. Desc: changed fields (list if more than 1)
     *
     * invalidFields - Type: string. Desc: invalid fields in the form (list if more than 1)
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: manage_page
     *
     * paymentCategory - Type: string. Desc: CreditCard,cardReader etc
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * visitorId - Type: guid.
     *
     * wpGeo - Type: string. Desc: wp geo
     * @param {validationErrorAtManagePageParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.validationErrorAtManagePage = function (params) {
        return this.bi.log(__assign({ evid: 274 }, params));
    };
    /**
    * @typedef {Object} checkoutPaymentComponentCollapsedParams
    * @property {GUID} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} cardId - card_id
    * @property {GUID} creditCardId - null if visitor is not logged in or doesn't have saved cc
    * @property {GUID} memberId - null if visitor is not logged in
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {GUID} orderId - vertical order id
    * @property {string} orderSnapshotId - order_snapshot_id
    * @property {string} paymentCategory - CreditCard/Ewallet,offline
    * @property {string} paymentProvider - com.stripe/net.authorize
    * @property {boolean} saveCreditCard - true if buyer wants to save CC
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Checkout - Payment Component Collapsed. Evid: 182.
     * Event description: Payment Component is collapsed after buyer clicked continue in Stores Checkout.
    
     * appId - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * cardId - Type: string. Desc: card_id
     *
     * creditCardId - Type: guid. Desc: null if visitor is not logged in or doesn't have saved cc
     *
     * memberId - Type: guid. Desc: null if visitor is not logged in
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * orderId - Type: guid. Desc: vertical order id
     *
     * orderSnapshotId - Type: string. Desc: order_snapshot_id
     *
     * paymentCategory - Type: string. Desc: CreditCard/Ewallet,offline
     *
     * paymentProvider - Type: string. Desc: com.stripe/net.authorize
     *
     * saveCreditCard - Type: bool. Desc: true if buyer wants to save CC
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {checkoutPaymentComponentCollapsedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.checkoutPaymentComponentCollapsed = function (params) {
        return this.bi.log(__assign({ evid: 182 }, params));
    };
    /**
    * @typedef {Object} expressCheckoutWidgetButtonClickedParams
    * @property {number} amountLong - amount * 100000
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} currency - currency
    * @property {GUID} msid - null
    * @property {string} origin - page type where widget was loaded
    * @property {string} paymentProvider - payment_provider
    * @property {string} paymentmethod - payment method that was choosed
    * @property {string} productId - product_id where widget is loaded
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Express checkout widget button clicked. Evid: 263.
     * Event description: When user click on button.
    
     * amountLong - Type: numeric. Desc: amount * 100000
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * currency - Type: string. Desc: currency
     *
     * msid - Type: guid.
     *
     * origin - Type: string. Desc: page type where widget was loaded
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * paymentmethod - Type: string. Desc: payment method that was choosed
     *
     * productId - Type: string. Desc: product_id where widget is loaded
     *
     * visitorId - Type: guid.
     * @param {expressCheckoutWidgetButtonClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.expressCheckoutWidgetButtonClicked = function (params) {
        return this.bi.log(__assign({ evid: 263 }, params));
    };
    /**
    * @typedef {Object} boSitePageTransactionRefundClickedParams
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page transaction refund clicked. Evid: 410.
     * Event description: Employee click refund from drawer.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boSitePageTransactionRefundClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageTransactionRefundClicked = function (params) {
        return this.bi.log(__assign({ evid: 410 }, params));
    };
    /**
    * @typedef {Object} boSitePageClickOnTransactionParams
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page click on transaction. Evid: 407.
     * Event description: Employee click on exact transaction.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boSitePageClickOnTransactionParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageClickOnTransaction = function (params) {
        return this.bi.log(__assign({ evid: 407 }, params));
    };
    /**
    * @typedef {Object} merchantCompleteSetUpBannerShownParams
    * @property {GUID} appId - app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - msid
    * @property {string} paymentCategory - creditCard,paypal
    * @property {string} paymentProvider - stripe,paypal,eWay
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant Complete Set-up Banner shown. Evid: 166.
     * Event description: In case when deferred account was created, user need to claim it.
    Banner notifies user.
    
     * appId - Type: guid. Desc: app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: msid
     *
     * paymentCategory - Type: string. Desc: creditCard,paypal
     *
     * paymentProvider - Type: string. Desc: stripe,paypal,eWay
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantCompleteSetUpBannerShownParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantCompleteSetUpBannerShown = function (params) {
        return this.bi.log(__assign({ evid: 166 }, params));
    };
    /**
    * @typedef {Object} applePayPaymentAuthorizedParams
    * @property {number} amountLong - amount * 100000
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} currency - currency
    * @property {GUID} msid - null
    * @property {string} orderSnapshotId - cashier order snapshot id
    * @property {string} paymentProvider - payment_provider
    * @property {string} paymentmethod - applepay
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: ApplePay payment authorized. Evid: 265.
     * Event description: When user confirm payment on ApplePay widget.
    
     * amountLong - Type: numeric. Desc: amount * 100000
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * currency - Type: string. Desc: currency
     *
     * msid - Type: guid.
     *
     * orderSnapshotId - Type: string. Desc: cashier order snapshot id
     *
     * paymentProvider - Type: string. Desc: payment_provider
     *
     * paymentmethod - Type: string. Desc: applepay
     *
     * visitorId - Type: guid.
     * @param {applePayPaymentAuthorizedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.applePayPaymentAuthorized = function (params) {
        return this.bi.log(__assign({ evid: 265 }, params));
    };
    /**
    * @typedef {Object} boAccountPageManualReviewOpenedParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {number} loadTime - loadtime
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - visitor id
    **/
    /**
     * Name: [BO] Account Page Manual Review opened. Evid: 438.
     * Event description: Employee open manual Review in account.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * loadTime - Type: numeric. Desc: loadtime
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid. Desc: visitor id
     * @param {boAccountPageManualReviewOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageManualReviewOpened = function (params) {
        return this.bi.log(__assign({ evid: 438 }, params));
    };
    /**
    * @typedef {Object} boMainPageSearchParams
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - null
    * @property {string} searchType - email, url, msid, uuid, etc
    * @property {string} value - value of search
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Main Page search. Evid: 401.
     * Event description: Employee input value and clicked 'Search'.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid.
     *
     * searchType - Type: string. Desc: email, url, msid, uuid, etc
     *
     * value - Type: string. Desc: value of search
     *
     * visitorId - Type: guid.
     * @param {boMainPageSearchParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boMainPageSearch = function (params) {
        return this.bi.log(__assign({ evid: 401 }, params));
    };
    /**
    * @typedef {Object} merchantGoToDashboardClickedParams
    * @property {GUID} msid - null
    * @property {string} paymentCategory - payment methods (sofort/iDeal etc.)
    * @property {string} paymentProvider - Stripe
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Go to Dashboard clicked. Evid: 256.
     * Event description: Go to Dashboard at Payment Page clicked.
    
     * msid - Type: guid.
     *
     * paymentCategory - Type: string. Desc: payment methods (sofort/iDeal etc.)
     *
     * paymentProvider - Type: string. Desc: Stripe
     *
     * visitorId - Type: guid.
     * @param {merchantGoToDashboardClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantGoToDashboardClicked = function (params) {
        return this.bi.log(__assign({ evid: 256 }, params));
    };
    /**
    * @typedef {Object} merchantClickOrderHardwareParams
    * @property {GUID} msid - null
    * @property {string} pageType - page where user at
    * @property {string} paymentCategory - payment method
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {string} place - place at candyshop
    * @property {string} platformName - desktop/oneApp etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Click Order Hardware. Evid: 279.
     * Event description: Click Order Hardware for POS at Accept Payments.
    
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: page where user at
     *
     * paymentCategory - Type: string. Desc: payment method
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * place - Type: string. Desc: place at candyshop
     *
     * platformName - Type: string. Desc: desktop/oneApp etc
     *
     * visitorId - Type: guid.
     * @param {merchantClickOrderHardwareParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickOrderHardware = function (params) {
        return this.bi.log(__assign({ evid: 279 }, params));
    };
    /**
    * @typedef {Object} merchantCreateProviderAccountToConnectClickedParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - Credit Card
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Create Provider Account to Connect clicked. Evid: 117.
     * Event description: click on create a new account on the payment method modal - smartOB - create in the payment method - connect/create account modal.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: Credit Card
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantCreateProviderAccountToConnectClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantCreateProviderAccountToConnectClicked = function (params) {
        return this.bi.log(__assign({ evid: 117 }, params));
    };
    /**
    * @typedef {Object} merchantConnectExistingProviderAccountClickedParams
    * @property {GUID} appId - TPA guid
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} errorDesc - the reason why merchant cant connect to the provider account
    * @property {boolean} isValid - 1-success 0- failed
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - Credit Card
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: Merchant - Connect Existing Provider Account clicked. Evid: 116.
     * Event description: click on connect on the payment method modal
    Merchant gets error when he can't access the payment method ( can't login to the provider) - smartOB - connect in the payment method - connect/create account modal.
    
     * appId - Type: guid. Desc: TPA guid
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * errorDesc - Type: string. Desc: the reason why merchant cant connect to the provider account
     *
     * isValid - Type: bool. Desc: 1-success 0- failed
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: Credit Card
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {merchantConnectExistingProviderAccountClickedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantConnectExistingProviderAccountClicked = function (params) {
        return this.bi.log(__assign({ evid: 116 }, params));
    };
    /**
    * @typedef {Object} merchantShowMoreLessProvidersClickedDuringOnboardingParams
    * @property {string} action - more / less
    * @property {GUID} appId - cashier app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {string} businessLocation - 2-letter country code of location selected by a user
    * @property {string} chosenMethods - list of available payment methods, shown by a default. Separated by comma
    * @property {string} hiddenMethods - list of hidden payment methods, separated by comma
    * @property {GUID} msid - msid
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Show more / less Providers Clicked during Onboarding. Evid: 186.
     * Event description: In a new onboarding, we show only major methods on a welcome page. this event tracks when users clicks show more / less methods.
    
     * action - Type: string. Desc: more / less
     *
     * appId - Type: guid. Desc: cashier app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * businessLocation - Type: string. Desc: 2-letter country code of location selected by a user
     *
     * chosenMethods - Type: string. Desc: list of available payment methods, shown by a default. Separated by comma
     *
     * hiddenMethods - Type: string. Desc: list of hidden payment methods, separated by comma
     *
     * msid - Type: guid. Desc: msid
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantShowMoreLessProvidersClickedDuringOnboardingParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantShowMoreLessProvidersClickedDuringOnboarding = function (params) {
        return this.bi.log(__assign({ evid: 186 }, params));
    };
    /**
    * @typedef {Object} boOpenProcessPayoutLightboxParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {number} loadTime - load time
    * @property {GUID} msid - msid
    * @property {string} tenantId - tenant id
    * @property {GUID} visitorId - visitor id
    **/
    /**
     * Name: [BO] open process payout lightbox. Evid: 237.
     * Event description: open process payout lightbox.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * loadTime - Type: numeric. Desc: load time
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string. Desc: tenant id
     *
     * visitorId - Type: guid. Desc: visitor id
     * @param {boOpenProcessPayoutLightboxParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boOpenProcessPayoutLightbox = function (params) {
        return this.bi.log(__assign({ evid: 237 }, params));
    };
    /**
    * @typedef {Object} merchantClickReviewRequirementsParams
    * @property {GUID} msid - null
    * @property {string} pageType - page where user at
    * @property {string} paymentCategory - payment method
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {string} platformName - desktop/oneApp/partner etc
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Click Review Requirements. Evid: 278.
     * Event description: Click Review Requirements for Account at Accept Payments.
    
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: page where user at
     *
     * paymentCategory - Type: string. Desc: payment method
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * platformName - Type: string. Desc: desktop/oneApp/partner etc
     *
     * visitorId - Type: guid.
     * @param {merchantClickReviewRequirementsParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantClickReviewRequirements = function (params) {
        return this.bi.log(__assign({ evid: 278 }, params));
    };
    /**
    * @typedef {Object} payoutsChangePayoutsFrequencyParams
    * @property {number} days - # of weekday / # of day of month
    * @property {GUID} msid - null
    * @property {string} pageType - manage_page
    * @property {string} scheduleType - payout schedule = frequency
    * @property {GUID} visitorId - null
    * @property {string} wpGeo - the country that the user selected
    **/
    /**
     * Name: Payouts - Change Payouts frequency. Evid: 271.
     * Event description: Change toggle for Payouts frequency in settings.
    
     * days - Type: numeric. Desc: # of weekday / # of day of month
     *
     * msid - Type: guid.
     *
     * pageType - Type: string. Desc: manage_page
     *
     * scheduleType - Type: string. Desc: payout schedule = frequency
     *
     * visitorId - Type: guid.
     *
     * wpGeo - Type: string. Desc: the country that the user selected
     * @param {payoutsChangePayoutsFrequencyParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.payoutsChangePayoutsFrequency = function (params) {
        return this.bi.log(__assign({ evid: 271 }, params));
    };
    /**
    * @typedef {Object} merchantSwitchAccountWithTransactionsConfirmClickedInPopupParams
    * @property {GUID} appId - cashier app_id
    * @property {GUID} appInstanceId - app_instance_id
    * @property {GUID} msid - synthetic msid for sites_by_src
    * @property {string} paymentCategory - Credit Card
    * @property {string} paymentProvider - authorize.net/Stripe/
    * @property {GUID} userGuid - user_guid
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: Merchant - Switch Account with transactions confirm clicked in popup. Evid: 179.
     * Event description: When merchant clicks on Switch account, having at least one transaction processed through this account, additional popup is shown. Event means that merchant confirmed this switch..
    
     * appId - Type: guid. Desc: cashier app_id
     *
     * appInstanceId - Type: guid. Desc: app_instance_id
     *
     * msid - Type: guid. Desc: synthetic msid for sites_by_src
     *
     * paymentCategory - Type: string. Desc: Credit Card
     *
     * paymentProvider - Type: string. Desc: authorize.net/Stripe/
     *
     * userGuid - Type: guid. Desc: user_guid
     *
     * visitorId - Type: guid.
     * @param {merchantSwitchAccountWithTransactionsConfirmClickedInPopupParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.merchantSwitchAccountWithTransactionsConfirmClickedInPopup = function (params) {
        return this.bi.log(__assign({ evid: 179 }, params));
    };
    /**
    * @typedef {Object} boSitePageTransactionRefundOpenedParams
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - visitor id
    **/
    /**
     * Name: [BO] Site Page transaction refund opened. Evid: 435.
     * Event description: Employee open refund from drawer.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid. Desc: visitor id
     * @param {boSitePageTransactionRefundOpenedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageTransactionRefundOpened = function (params) {
        return this.bi.log(__assign({ evid: 435 }, params));
    };
    /**
    * @typedef {Object} boAccountPageClickCancelProcessPayoutParams
    * @property {GUID} accountId - provider account id
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {string} tenantId - null
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Account Page click  Cancel  Process Payout. Evid: 423.
     * Event description: Employee click Cancel  Process Payout.
    
     * accountId - Type: guid. Desc: provider account id
     *
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * tenantId - Type: string.
     *
     * visitorId - Type: guid.
     * @param {boAccountPageClickCancelProcessPayoutParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boAccountPageClickCancelProcessPayout = function (params) {
        return this.bi.log(__assign({ evid: 423 }, params));
    };
    /**
    * @typedef {Object} boSitePageTransactionRefundClickXParams
    * @property {string} displayName - employee displayName
    * @property {GUID} msid - msid
    * @property {GUID} transactionid - transaction id
    * @property {GUID} visitorId - null
    **/
    /**
     * Name: [BO] Site Page transaction refund click [x]. Evid: 413.
     * Event description: Employee click [x] on refund dialogue.
    
     * displayName - Type: string. Desc: employee displayName
     *
     * msid - Type: guid. Desc: msid
     *
     * transactionid - Type: guid. Desc: transaction id
     *
     * visitorId - Type: guid.
     * @param {boSitePageTransactionRefundClickXParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.boSitePageTransactionRefundClickX = function (params) {
        return this.bi.log(__assign({ evid: 413 }, params));
    };
    /**
    * @typedef {Object} spbButtonTrxAuthorizedParams
    * @property {string} cartId - cart id
    * @property {GUID} msid - msid
    * @property {string} paymentProvider - payment_provider that chosen (PayPal, Wixpayments etc.)
    * @property {string} paymentmethod - payment method in provider (Venmo, PayPal Credit etc.)
    * @property {string} sessionId - unique payment session to connect orders and trxs
    * @property {GUID} visitorId - visitor_id
    **/
    /**
     * Name: SPB button trx authorized. Evid: 216.
     * Event description: Transaction successfully authorized and PP modal is closed..
    
     * cartId - Type: string. Desc: cart id
     *
     * msid - Type: guid. Desc: msid
     *
     * paymentProvider - Type: string. Desc: payment_provider that chosen (PayPal, Wixpayments etc.)
     *
     * paymentmethod - Type: string. Desc: payment method in provider (Venmo, PayPal Credit etc.)
     *
     * sessionId - Type: string. Desc: unique payment session to connect orders and trxs
     *
     * visitorId - Type: guid. Desc: visitor_id
     * @param {spbButtonTrxAuthorizedParams} params The parameters for this event.
     * @return {Promise} Promise
    **/
    Logger.prototype.spbButtonTrxAuthorized = function (params) {
        return this.bi.log(__assign({ evid: 216 }, params));
    };
    return Logger;
}());
export { Logger };
export default init;
export function getLoggerConf() {
    return {
        src: 64,
        endpoint: 'cashier-ugc',
    };
}
//# sourceMappingURL=index.js.map